
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("WqSvO", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $0afa4459cb80038e$var$isNil(value) {
    return value == null;
}
module.exports = $0afa4459cb80038e$var$isNil;

});

parcelRegister("dt1y6", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cdf2f653d8e5d6b$export$2e2bcd8739ae039);

var $6fVJB = parcelRequire("6fVJB");

var $jExiB = parcelRequire("jExiB");

var $32dmS = parcelRequire("32dmS");

var $9qU6H = parcelRequire("9qU6H");

var $4pbqu = parcelRequire("4pbqu");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $9cdf2f653d8e5d6b$var$locale = {
    code: 'ar-DZ',
    formatDistance: (0, $6fVJB.default),
    formatLong: (0, $jExiB.default),
    formatRelative: (0, $32dmS.default),
    localize: (0, $9qU6H.default),
    match: (0, $4pbqu.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $9cdf2f653d8e5d6b$export$2e2bcd8739ae039 = $9cdf2f653d8e5d6b$var$locale;

});
parcelRegister("6fVJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $48e0edaa0d4512f6$export$2e2bcd8739ae039);
var $48e0edaa0d4512f6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $48e0edaa0d4512f6$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $48e0edaa0d4512f6$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $48e0edaa0d4512f6$export$2e2bcd8739ae039 = $48e0edaa0d4512f6$var$formatDistance;

});

parcelRegister("jExiB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4eb953b0b730594$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $e4eb953b0b730594$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $e4eb953b0b730594$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $e4eb953b0b730594$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e4eb953b0b730594$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $e4eb953b0b730594$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $e4eb953b0b730594$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $e4eb953b0b730594$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e4eb953b0b730594$export$2e2bcd8739ae039 = $e4eb953b0b730594$var$formatLong;

});

parcelRegister("32dmS", function(module, exports) {
$parcel$export(module.exports, "default", () => $235bed9e7138dc7a$export$2e2bcd8739ae039);
var $235bed9e7138dc7a$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $235bed9e7138dc7a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $235bed9e7138dc7a$var$formatRelativeLocale[token];
};
var $235bed9e7138dc7a$export$2e2bcd8739ae039 = $235bed9e7138dc7a$var$formatRelative;

});

parcelRegister("9qU6H", function(module, exports) {
$parcel$export(module.exports, "default", () => $6de210735f742a23$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $6de210735f742a23$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $6de210735f742a23$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $6de210735f742a23$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $6de210735f742a23$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $6de210735f742a23$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $6de210735f742a23$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $6de210735f742a23$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $6de210735f742a23$var$localize = {
    ordinalNumber: $6de210735f742a23$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $6de210735f742a23$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $6de210735f742a23$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $6de210735f742a23$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $6de210735f742a23$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $6de210735f742a23$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6de210735f742a23$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6de210735f742a23$export$2e2bcd8739ae039 = $6de210735f742a23$var$localize;

});

parcelRegister("4pbqu", function(module, exports) {
$parcel$export(module.exports, "default", () => $33525c4359b45e6d$export$2e2bcd8739ae039);

var $Bwtuj = parcelRequire("Bwtuj");

var $jTS6J = parcelRequire("jTS6J");
var $33525c4359b45e6d$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $33525c4359b45e6d$var$parseOrdinalNumberPattern = /\d+/i;
var $33525c4359b45e6d$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $33525c4359b45e6d$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $33525c4359b45e6d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $33525c4359b45e6d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $33525c4359b45e6d$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $33525c4359b45e6d$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $33525c4359b45e6d$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $33525c4359b45e6d$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $33525c4359b45e6d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $33525c4359b45e6d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $33525c4359b45e6d$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $33525c4359b45e6d$var$matchOrdinalNumberPattern,
        parsePattern: $33525c4359b45e6d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $33525c4359b45e6d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $33525c4359b45e6d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $33525c4359b45e6d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $33525c4359b45e6d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $33525c4359b45e6d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $33525c4359b45e6d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $33525c4359b45e6d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $33525c4359b45e6d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $33525c4359b45e6d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $33525c4359b45e6d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $33525c4359b45e6d$export$2e2bcd8739ae039 = $33525c4359b45e6d$var$match;

});


parcelRegister("49Ri2", function(module, exports) {
$parcel$export(module.exports, "default", () => $307156f15882a7ae$export$2e2bcd8739ae039);

var $2YF8c = parcelRequire("2YF8c");

var $6g4o2 = parcelRequire("6g4o2");

var $iS6uT = parcelRequire("iS6uT");

var $3jryQ = parcelRequire("3jryQ");

var $1W7SR = parcelRequire("1W7SR");
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $307156f15882a7ae$var$locale = {
    code: 'cs',
    formatDistance: (0, $2YF8c.default),
    formatLong: (0, $6g4o2.default),
    formatRelative: (0, $iS6uT.default),
    localize: (0, $3jryQ.default),
    match: (0, $1W7SR.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $307156f15882a7ae$export$2e2bcd8739ae039 = $307156f15882a7ae$var$locale;

});
parcelRegister("2YF8c", function(module, exports) {
$parcel$export(module.exports, "default", () => $22b1173083247ce1$export$2e2bcd8739ae039);
var $22b1173083247ce1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var $22b1173083247ce1$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $22b1173083247ce1$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
var $22b1173083247ce1$export$2e2bcd8739ae039 = $22b1173083247ce1$var$formatDistance;

});

parcelRegister("6g4o2", function(module, exports) {
$parcel$export(module.exports, "default", () => $48e7a3d1a256456e$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $48e7a3d1a256456e$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var $48e7a3d1a256456e$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $48e7a3d1a256456e$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $48e7a3d1a256456e$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $48e7a3d1a256456e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $48e7a3d1a256456e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $48e7a3d1a256456e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $48e7a3d1a256456e$export$2e2bcd8739ae039 = $48e7a3d1a256456e$var$formatLong;

});

parcelRegister("iS6uT", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbd24f5e3c9dba6e$export$2e2bcd8739ae039);
var $dbd24f5e3c9dba6e$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var $dbd24f5e3c9dba6e$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $dbd24f5e3c9dba6e$var$accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var $dbd24f5e3c9dba6e$var$formatRelative = function formatRelative(token, date) {
    var format = $dbd24f5e3c9dba6e$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $dbd24f5e3c9dba6e$export$2e2bcd8739ae039 = $dbd24f5e3c9dba6e$var$formatRelative;

});

parcelRegister("3jryQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2698867f116e64c5$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $2698867f116e64c5$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $2698867f116e64c5$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $2698867f116e64c5$var$monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var $2698867f116e64c5$var$formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var $2698867f116e64c5$var$dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var $2698867f116e64c5$var$dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $2698867f116e64c5$var$formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $2698867f116e64c5$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $2698867f116e64c5$var$localize = {
    ordinalNumber: $2698867f116e64c5$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $2698867f116e64c5$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $2698867f116e64c5$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $2698867f116e64c5$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $2698867f116e64c5$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $2698867f116e64c5$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $2698867f116e64c5$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $2698867f116e64c5$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2698867f116e64c5$export$2e2bcd8739ae039 = $2698867f116e64c5$var$localize;

});

parcelRegister("1W7SR", function(module, exports) {
$parcel$export(module.exports, "default", () => $169152ce35abf136$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $169152ce35abf136$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $169152ce35abf136$var$parseOrdinalNumberPattern = /\d+/i;
var $169152ce35abf136$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $169152ce35abf136$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $169152ce35abf136$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $169152ce35abf136$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $169152ce35abf136$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $169152ce35abf136$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $169152ce35abf136$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $169152ce35abf136$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $169152ce35abf136$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $169152ce35abf136$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $169152ce35abf136$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $169152ce35abf136$var$matchOrdinalNumberPattern,
        parsePattern: $169152ce35abf136$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $169152ce35abf136$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $169152ce35abf136$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $169152ce35abf136$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $169152ce35abf136$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $169152ce35abf136$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $169152ce35abf136$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $169152ce35abf136$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $169152ce35abf136$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $169152ce35abf136$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $169152ce35abf136$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $169152ce35abf136$export$2e2bcd8739ae039 = $169152ce35abf136$var$match;

});


parcelRegister("8TAdq", function(module, exports) {
$parcel$export(module.exports, "default", () => $679f8d717b03dbe1$export$2e2bcd8739ae039);

var $loWUo = parcelRequire("loWUo");

var $5WyvM = parcelRequire("5WyvM");

var $2BN7W = parcelRequire("2BN7W");

var $f0e2K = parcelRequire("f0e2K");

var $jkwad = parcelRequire("jkwad");
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $679f8d717b03dbe1$var$locale = {
    code: 'da',
    formatDistance: (0, $loWUo.default),
    formatLong: (0, $5WyvM.default),
    formatRelative: (0, $2BN7W.default),
    localize: (0, $f0e2K.default),
    match: (0, $jkwad.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $679f8d717b03dbe1$export$2e2bcd8739ae039 = $679f8d717b03dbe1$var$locale;

});
parcelRegister("loWUo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f94988de45599235$export$2e2bcd8739ae039);
var $f94988de45599235$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $f94988de45599235$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f94988de45599235$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $f94988de45599235$export$2e2bcd8739ae039 = $f94988de45599235$var$formatDistance;

});

parcelRegister("5WyvM", function(module, exports) {
$parcel$export(module.exports, "default", () => $453d23d6333a853b$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $453d23d6333a853b$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var $453d23d6333a853b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $453d23d6333a853b$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $453d23d6333a853b$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $453d23d6333a853b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $453d23d6333a853b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $453d23d6333a853b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $453d23d6333a853b$export$2e2bcd8739ae039 = $453d23d6333a853b$var$formatLong;

});

parcelRegister("2BN7W", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e652518075e8ace$export$2e2bcd8739ae039);
var $1e652518075e8ace$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var $1e652518075e8ace$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1e652518075e8ace$var$formatRelativeLocale[token];
};
var $1e652518075e8ace$export$2e2bcd8739ae039 = $1e652518075e8ace$var$formatRelative;

});

parcelRegister("f0e2K", function(module, exports) {
$parcel$export(module.exports, "default", () => $aec1bfd0da6ddca4$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $aec1bfd0da6ddca4$var$eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var $aec1bfd0da6ddca4$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $aec1bfd0da6ddca4$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $aec1bfd0da6ddca4$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $aec1bfd0da6ddca4$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var $aec1bfd0da6ddca4$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var $aec1bfd0da6ddca4$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $aec1bfd0da6ddca4$var$localize = {
    ordinalNumber: $aec1bfd0da6ddca4$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $aec1bfd0da6ddca4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $aec1bfd0da6ddca4$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $aec1bfd0da6ddca4$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $aec1bfd0da6ddca4$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $aec1bfd0da6ddca4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $aec1bfd0da6ddca4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $aec1bfd0da6ddca4$export$2e2bcd8739ae039 = $aec1bfd0da6ddca4$var$localize;

});

parcelRegister("jkwad", function(module, exports) {
$parcel$export(module.exports, "default", () => $e128d59ffb22d795$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $e128d59ffb22d795$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $e128d59ffb22d795$var$parseOrdinalNumberPattern = /\d+/i;
var $e128d59ffb22d795$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $e128d59ffb22d795$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $e128d59ffb22d795$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $e128d59ffb22d795$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e128d59ffb22d795$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $e128d59ffb22d795$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e128d59ffb22d795$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $e128d59ffb22d795$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $e128d59ffb22d795$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $e128d59ffb22d795$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $e128d59ffb22d795$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $e128d59ffb22d795$var$matchOrdinalNumberPattern,
        parsePattern: $e128d59ffb22d795$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $e128d59ffb22d795$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e128d59ffb22d795$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $e128d59ffb22d795$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e128d59ffb22d795$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $e128d59ffb22d795$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e128d59ffb22d795$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $e128d59ffb22d795$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e128d59ffb22d795$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $e128d59ffb22d795$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e128d59ffb22d795$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e128d59ffb22d795$export$2e2bcd8739ae039 = $e128d59ffb22d795$var$match;

});


parcelRegister("21fcH", function(module, exports) {
$parcel$export(module.exports, "default", () => $178777e7f0619540$export$2e2bcd8739ae039);

var $ebBLi = parcelRequire("ebBLi");

var $a4rBv = parcelRequire("a4rBv");

var $jJpM9 = parcelRequire("jJpM9");

var $69chY = parcelRequire("69chY");

var $60qa1 = parcelRequire("60qa1");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $178777e7f0619540$var$locale = {
    code: 'de',
    formatDistance: (0, $ebBLi.default),
    formatLong: (0, $a4rBv.default),
    formatRelative: (0, $jJpM9.default),
    localize: (0, $69chY.default),
    match: (0, $60qa1.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $178777e7f0619540$export$2e2bcd8739ae039 = $178777e7f0619540$var$locale;

});
parcelRegister("ebBLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $a53f6281ba6a5030$export$2e2bcd8739ae039);
var $a53f6281ba6a5030$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $a53f6281ba6a5030$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $a53f6281ba6a5030$var$formatDistanceLocale[token].withPreposition : $a53f6281ba6a5030$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $a53f6281ba6a5030$export$2e2bcd8739ae039 = $a53f6281ba6a5030$var$formatDistance;

});

parcelRegister("a4rBv", function(module, exports) {
$parcel$export(module.exports, "default", () => $754fb0a94d4ab237$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $754fb0a94d4ab237$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $754fb0a94d4ab237$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $754fb0a94d4ab237$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $754fb0a94d4ab237$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $754fb0a94d4ab237$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $754fb0a94d4ab237$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $754fb0a94d4ab237$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $754fb0a94d4ab237$export$2e2bcd8739ae039 = $754fb0a94d4ab237$var$formatLong;

});

parcelRegister("jJpM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5d636cddb11d206$export$2e2bcd8739ae039);
var $e5d636cddb11d206$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $e5d636cddb11d206$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e5d636cddb11d206$var$formatRelativeLocale[token];
};
var $e5d636cddb11d206$export$2e2bcd8739ae039 = $e5d636cddb11d206$var$formatRelative;

});

parcelRegister("69chY", function(module, exports) {
$parcel$export(module.exports, "default", () => $479d1da659288d86$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $479d1da659288d86$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $479d1da659288d86$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $479d1da659288d86$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $479d1da659288d86$var$formattingMonthValues = {
    narrow: $479d1da659288d86$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $479d1da659288d86$var$monthValues.wide
};
var $479d1da659288d86$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $479d1da659288d86$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $479d1da659288d86$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $479d1da659288d86$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $479d1da659288d86$var$localize = {
    ordinalNumber: $479d1da659288d86$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $479d1da659288d86$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $479d1da659288d86$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $479d1da659288d86$var$monthValues,
        formattingValues: $479d1da659288d86$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $479d1da659288d86$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $479d1da659288d86$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $479d1da659288d86$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $479d1da659288d86$export$2e2bcd8739ae039 = $479d1da659288d86$var$localize;

});

parcelRegister("60qa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $45f7091de58712c9$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $45f7091de58712c9$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $45f7091de58712c9$var$parseOrdinalNumberPattern = /\d+/i;
var $45f7091de58712c9$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $45f7091de58712c9$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $45f7091de58712c9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $45f7091de58712c9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $45f7091de58712c9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $45f7091de58712c9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $45f7091de58712c9$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $45f7091de58712c9$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $45f7091de58712c9$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $45f7091de58712c9$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $45f7091de58712c9$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $45f7091de58712c9$var$matchOrdinalNumberPattern,
        parsePattern: $45f7091de58712c9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $45f7091de58712c9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45f7091de58712c9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $45f7091de58712c9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45f7091de58712c9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $45f7091de58712c9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45f7091de58712c9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $45f7091de58712c9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45f7091de58712c9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $45f7091de58712c9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45f7091de58712c9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $45f7091de58712c9$export$2e2bcd8739ae039 = $45f7091de58712c9$var$match;

});


parcelRegister("3xzlf", function(module, exports) {
$parcel$export(module.exports, "default", () => $293fde49280a6662$export$2e2bcd8739ae039);

var $g0r6b = parcelRequire("g0r6b");

var $5dpUp = parcelRequire("5dpUp");

var $9euoL = parcelRequire("9euoL");

var $gZkWF = parcelRequire("gZkWF");

var $6DIQn = parcelRequire("6DIQn");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $293fde49280a6662$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $g0r6b.default),
    formatLong: (0, $5dpUp.default),
    formatRelative: (0, $9euoL.default),
    localize: (0, $gZkWF.default),
    match: (0, $6DIQn.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $293fde49280a6662$export$2e2bcd8739ae039 = $293fde49280a6662$var$locale;

});
parcelRegister("5dpUp", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cc24397af544738$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $3cc24397af544738$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $3cc24397af544738$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $3cc24397af544738$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $3cc24397af544738$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $3cc24397af544738$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $3cc24397af544738$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $3cc24397af544738$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3cc24397af544738$export$2e2bcd8739ae039 = $3cc24397af544738$var$formatLong;

});


parcelRegister("fgiQ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c6f673152124d5$export$2e2bcd8739ae039);

var $g0r6b = parcelRequire("g0r6b");

var $9euoL = parcelRequire("9euoL");

var $gZkWF = parcelRequire("gZkWF");

var $6DIQn = parcelRequire("6DIQn");

var $di30v = parcelRequire("di30v");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $b1c6f673152124d5$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $g0r6b.default),
    formatLong: (0, $di30v.default),
    formatRelative: (0, $9euoL.default),
    localize: (0, $gZkWF.default),
    match: (0, $6DIQn.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b1c6f673152124d5$export$2e2bcd8739ae039 = $b1c6f673152124d5$var$locale;

});
parcelRegister("di30v", function(module, exports) {
$parcel$export(module.exports, "default", () => $9acf49f86340c6fb$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $9acf49f86340c6fb$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $9acf49f86340c6fb$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $9acf49f86340c6fb$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9acf49f86340c6fb$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $9acf49f86340c6fb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $9acf49f86340c6fb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $9acf49f86340c6fb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9acf49f86340c6fb$export$2e2bcd8739ae039 = $9acf49f86340c6fb$var$formatLong;

});


parcelRegister("gtbIq", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfd8713a72fab9f6$export$2e2bcd8739ae039);

var $3NftU = parcelRequire("3NftU");

var $2T6o5 = parcelRequire("2T6o5");

var $1XHSK = parcelRequire("1XHSK");

var $aqp7k = parcelRequire("aqp7k");

var $jHSzJ = parcelRequire("jHSzJ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $bfd8713a72fab9f6$var$locale = {
    code: 'es',
    formatDistance: (0, $3NftU.default),
    formatLong: (0, $2T6o5.default),
    formatRelative: (0, $1XHSK.default),
    localize: (0, $aqp7k.default),
    match: (0, $jHSzJ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $bfd8713a72fab9f6$export$2e2bcd8739ae039 = $bfd8713a72fab9f6$var$locale;

});
parcelRegister("3NftU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c31f4fcefba02c3$export$2e2bcd8739ae039);
var $2c31f4fcefba02c3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $2c31f4fcefba02c3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2c31f4fcefba02c3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
var $2c31f4fcefba02c3$export$2e2bcd8739ae039 = $2c31f4fcefba02c3$var$formatDistance;

});

parcelRegister("2T6o5", function(module, exports) {
$parcel$export(module.exports, "default", () => $21a5ac40f525228c$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $21a5ac40f525228c$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $21a5ac40f525228c$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $21a5ac40f525228c$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $21a5ac40f525228c$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $21a5ac40f525228c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $21a5ac40f525228c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $21a5ac40f525228c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $21a5ac40f525228c$export$2e2bcd8739ae039 = $21a5ac40f525228c$var$formatLong;

});

parcelRegister("1XHSK", function(module, exports) {
$parcel$export(module.exports, "default", () => $16dd572fc9913c56$export$2e2bcd8739ae039);
var $16dd572fc9913c56$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $16dd572fc9913c56$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var $16dd572fc9913c56$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $16dd572fc9913c56$var$formatRelativeLocalePlural[token];
    else return $16dd572fc9913c56$var$formatRelativeLocale[token];
};
var $16dd572fc9913c56$export$2e2bcd8739ae039 = $16dd572fc9913c56$var$formatRelative;

});

parcelRegister("aqp7k", function(module, exports) {
$parcel$export(module.exports, "default", () => $796fd0d886a0586e$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $796fd0d886a0586e$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $796fd0d886a0586e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $796fd0d886a0586e$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $796fd0d886a0586e$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $796fd0d886a0586e$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $796fd0d886a0586e$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var $796fd0d886a0586e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $796fd0d886a0586e$var$localize = {
    ordinalNumber: $796fd0d886a0586e$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $796fd0d886a0586e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $796fd0d886a0586e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $796fd0d886a0586e$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $796fd0d886a0586e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $796fd0d886a0586e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $796fd0d886a0586e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $796fd0d886a0586e$export$2e2bcd8739ae039 = $796fd0d886a0586e$var$localize;

});

parcelRegister("jHSzJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e58c5dfd3af525db$export$2e2bcd8739ae039);

var $Bwtuj = parcelRequire("Bwtuj");

var $jTS6J = parcelRequire("jTS6J");
var $e58c5dfd3af525db$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $e58c5dfd3af525db$var$parseOrdinalNumberPattern = /\d+/i;
var $e58c5dfd3af525db$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $e58c5dfd3af525db$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $e58c5dfd3af525db$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $e58c5dfd3af525db$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e58c5dfd3af525db$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $e58c5dfd3af525db$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $e58c5dfd3af525db$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $e58c5dfd3af525db$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $e58c5dfd3af525db$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $e58c5dfd3af525db$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $e58c5dfd3af525db$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $e58c5dfd3af525db$var$matchOrdinalNumberPattern,
        parsePattern: $e58c5dfd3af525db$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $e58c5dfd3af525db$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e58c5dfd3af525db$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $e58c5dfd3af525db$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e58c5dfd3af525db$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $e58c5dfd3af525db$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e58c5dfd3af525db$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $e58c5dfd3af525db$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e58c5dfd3af525db$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $e58c5dfd3af525db$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e58c5dfd3af525db$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e58c5dfd3af525db$export$2e2bcd8739ae039 = $e58c5dfd3af525db$var$match;

});


parcelRegister("7dVeQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $542625abf028d3f6$export$2e2bcd8739ae039);

var $24whn = parcelRequire("24whn");

var $80lqz = parcelRequire("80lqz");

var $jHv1k = parcelRequire("jHv1k");

var $8tHuu = parcelRequire("8tHuu");

var $1EFWB = parcelRequire("1EFWB");
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $542625abf028d3f6$var$locale = {
    code: 'et',
    formatDistance: (0, $24whn.default),
    formatLong: (0, $80lqz.default),
    formatRelative: (0, $jHv1k.default),
    localize: (0, $8tHuu.default),
    match: (0, $1EFWB.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $542625abf028d3f6$export$2e2bcd8739ae039 = $542625abf028d3f6$var$locale;

});
parcelRegister("24whn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1824fe7f4bd7bc03$export$2e2bcd8739ae039);
var $1824fe7f4bd7bc03$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var $1824fe7f4bd7bc03$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $1824fe7f4bd7bc03$var$formatDistanceLocale[token].withPreposition : $1824fe7f4bd7bc03$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
var $1824fe7f4bd7bc03$export$2e2bcd8739ae039 = $1824fe7f4bd7bc03$var$formatDistance;

});

parcelRegister("80lqz", function(module, exports) {
$parcel$export(module.exports, "default", () => $018103e6bee6a287$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $018103e6bee6a287$var$dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $018103e6bee6a287$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $018103e6bee6a287$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var $018103e6bee6a287$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $018103e6bee6a287$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $018103e6bee6a287$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $018103e6bee6a287$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $018103e6bee6a287$export$2e2bcd8739ae039 = $018103e6bee6a287$var$formatLong;

});

parcelRegister("jHv1k", function(module, exports) {
$parcel$export(module.exports, "default", () => $e57a187c74a70f60$export$2e2bcd8739ae039);
var $e57a187c74a70f60$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var $e57a187c74a70f60$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e57a187c74a70f60$var$formatRelativeLocale[token];
};
var $e57a187c74a70f60$export$2e2bcd8739ae039 = $e57a187c74a70f60$var$formatRelative;

});

parcelRegister("8tHuu", function(module, exports) {
$parcel$export(module.exports, "default", () => $62c2c488bdc449f4$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $62c2c488bdc449f4$var$eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $62c2c488bdc449f4$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $62c2c488bdc449f4$var$monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var $62c2c488bdc449f4$var$dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var $62c2c488bdc449f4$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $62c2c488bdc449f4$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $62c2c488bdc449f4$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $62c2c488bdc449f4$var$localize = {
    ordinalNumber: $62c2c488bdc449f4$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $62c2c488bdc449f4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $62c2c488bdc449f4$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $62c2c488bdc449f4$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $62c2c488bdc449f4$var$monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $62c2c488bdc449f4$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $62c2c488bdc449f4$var$dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $62c2c488bdc449f4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $62c2c488bdc449f4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $62c2c488bdc449f4$export$2e2bcd8739ae039 = $62c2c488bdc449f4$var$localize;

});

parcelRegister("1EFWB", function(module, exports) {
$parcel$export(module.exports, "default", () => $134a1022430e7a48$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $134a1022430e7a48$var$matchOrdinalNumberPattern = /^\d+\./i;
var $134a1022430e7a48$var$parseOrdinalNumberPattern = /\d+/i;
var $134a1022430e7a48$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $134a1022430e7a48$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $134a1022430e7a48$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $134a1022430e7a48$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $134a1022430e7a48$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $134a1022430e7a48$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $134a1022430e7a48$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $134a1022430e7a48$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $134a1022430e7a48$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $134a1022430e7a48$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $134a1022430e7a48$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $134a1022430e7a48$var$matchOrdinalNumberPattern,
        parsePattern: $134a1022430e7a48$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $134a1022430e7a48$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $134a1022430e7a48$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $134a1022430e7a48$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $134a1022430e7a48$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $134a1022430e7a48$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $134a1022430e7a48$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $134a1022430e7a48$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $134a1022430e7a48$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $134a1022430e7a48$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $134a1022430e7a48$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $134a1022430e7a48$export$2e2bcd8739ae039 = $134a1022430e7a48$var$match;

});


parcelRegister("gKLIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $c325f63e8ecda64d$export$2e2bcd8739ae039);

var $kDK2l = parcelRequire("kDK2l");

var $6dQr5 = parcelRequire("6dQr5");

var $jPRLn = parcelRequire("jPRLn");

var $fScRo = parcelRequire("fScRo");

var $81ToV = parcelRequire("81ToV");
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $c325f63e8ecda64d$var$locale = {
    code: 'fi',
    formatDistance: (0, $kDK2l.default),
    formatLong: (0, $6dQr5.default),
    formatRelative: (0, $jPRLn.default),
    localize: (0, $fScRo.default),
    match: (0, $81ToV.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c325f63e8ecda64d$export$2e2bcd8739ae039 = $c325f63e8ecda64d$var$locale;

});
parcelRegister("kDK2l", function(module, exports) {
$parcel$export(module.exports, "default", () => $f06b291d3d82abf0$export$2e2bcd8739ae039);
function $f06b291d3d82abf0$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function $f06b291d3d82abf0$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function $f06b291d3d82abf0$var$futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function $f06b291d3d82abf0$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $f06b291d3d82abf0$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function $f06b291d3d82abf0$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function $f06b291d3d82abf0$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var $f06b291d3d82abf0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: $f06b291d3d82abf0$var$futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: $f06b291d3d82abf0$var$futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: $f06b291d3d82abf0$var$futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: $f06b291d3d82abf0$var$futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: $f06b291d3d82abf0$var$futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: $f06b291d3d82abf0$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $f06b291d3d82abf0$var$futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: $f06b291d3d82abf0$var$futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: $f06b291d3d82abf0$var$futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: $f06b291d3d82abf0$var$futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: $f06b291d3d82abf0$var$futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: $f06b291d3d82abf0$var$futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: $f06b291d3d82abf0$var$futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: $f06b291d3d82abf0$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $f06b291d3d82abf0$var$futureYears
    }
};
var $f06b291d3d82abf0$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $f06b291d3d82abf0$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
var $f06b291d3d82abf0$export$2e2bcd8739ae039 = $f06b291d3d82abf0$var$formatDistance;

});

parcelRegister("6dQr5", function(module, exports) {
$parcel$export(module.exports, "default", () => $487ca1a4939d7db6$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $487ca1a4939d7db6$var$dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var $487ca1a4939d7db6$var$timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var $487ca1a4939d7db6$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $487ca1a4939d7db6$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $487ca1a4939d7db6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $487ca1a4939d7db6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $487ca1a4939d7db6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $487ca1a4939d7db6$export$2e2bcd8739ae039 = $487ca1a4939d7db6$var$formatLong;

});

parcelRegister("jPRLn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e70c7c00c2adf14f$export$2e2bcd8739ae039);
var $e70c7c00c2adf14f$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var $e70c7c00c2adf14f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e70c7c00c2adf14f$var$formatRelativeLocale[token];
};
var $e70c7c00c2adf14f$export$2e2bcd8739ae039 = $e70c7c00c2adf14f$var$formatRelative;

});

parcelRegister("fScRo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8e5dfede7134de3$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $b8e5dfede7134de3$var$eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $b8e5dfede7134de3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var $b8e5dfede7134de3$var$monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var $b8e5dfede7134de3$var$formattingMonthValues = {
    narrow: $b8e5dfede7134de3$var$monthValues.narrow,
    abbreviated: $b8e5dfede7134de3$var$monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var $b8e5dfede7134de3$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var $b8e5dfede7134de3$var$formattingDayValues = {
    narrow: $b8e5dfede7134de3$var$dayValues.narrow,
    short: $b8e5dfede7134de3$var$dayValues.short,
    abbreviated: $b8e5dfede7134de3$var$dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var $b8e5dfede7134de3$var$dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var $b8e5dfede7134de3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $b8e5dfede7134de3$var$localize = {
    ordinalNumber: $b8e5dfede7134de3$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $b8e5dfede7134de3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $b8e5dfede7134de3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $b8e5dfede7134de3$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $b8e5dfede7134de3$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $b8e5dfede7134de3$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $b8e5dfede7134de3$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $b8e5dfede7134de3$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $b8e5dfede7134de3$export$2e2bcd8739ae039 = $b8e5dfede7134de3$var$localize;

});

parcelRegister("81ToV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d896437662e0991$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $5d896437662e0991$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $5d896437662e0991$var$parseOrdinalNumberPattern = /\d+/i;
var $5d896437662e0991$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $5d896437662e0991$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $5d896437662e0991$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $5d896437662e0991$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5d896437662e0991$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $5d896437662e0991$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $5d896437662e0991$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $5d896437662e0991$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $5d896437662e0991$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $5d896437662e0991$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $5d896437662e0991$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $5d896437662e0991$var$matchOrdinalNumberPattern,
        parsePattern: $5d896437662e0991$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $5d896437662e0991$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d896437662e0991$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $5d896437662e0991$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d896437662e0991$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $5d896437662e0991$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d896437662e0991$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $5d896437662e0991$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d896437662e0991$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $5d896437662e0991$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5d896437662e0991$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5d896437662e0991$export$2e2bcd8739ae039 = $5d896437662e0991$var$match;

});


parcelRegister("cuaUr", function(module, exports) {
$parcel$export(module.exports, "default", () => $9170bfbab6f82efd$export$2e2bcd8739ae039);

var $gEXn8 = parcelRequire("gEXn8");

var $dRAAP = parcelRequire("dRAAP");

var $lUxRM = parcelRequire("lUxRM");

var $ksV08 = parcelRequire("ksV08");

var $hK2kn = parcelRequire("hK2kn");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $9170bfbab6f82efd$var$locale = {
    code: 'fr',
    formatDistance: (0, $gEXn8.default),
    formatLong: (0, $dRAAP.default),
    formatRelative: (0, $lUxRM.default),
    localize: (0, $ksV08.default),
    match: (0, $hK2kn.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9170bfbab6f82efd$export$2e2bcd8739ae039 = $9170bfbab6f82efd$var$locale;

});
parcelRegister("gEXn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $c20e6fd1f7055d64$export$2e2bcd8739ae039);
var $c20e6fd1f7055d64$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $c20e6fd1f7055d64$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $c20e6fd1f7055d64$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $c20e6fd1f7055d64$export$2e2bcd8739ae039 = $c20e6fd1f7055d64$var$formatDistance;

});

parcelRegister("dRAAP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a17c9c39c5a6eae2$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $a17c9c39c5a6eae2$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $a17c9c39c5a6eae2$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a17c9c39c5a6eae2$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a17c9c39c5a6eae2$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $a17c9c39c5a6eae2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $a17c9c39c5a6eae2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $a17c9c39c5a6eae2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a17c9c39c5a6eae2$export$2e2bcd8739ae039 = $a17c9c39c5a6eae2$var$formatLong;

});

parcelRegister("lUxRM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff39191597d400db$export$2e2bcd8739ae039);
var $ff39191597d400db$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $ff39191597d400db$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ff39191597d400db$var$formatRelativeLocale[token];
};
var $ff39191597d400db$export$2e2bcd8739ae039 = $ff39191597d400db$var$formatRelative;

});

parcelRegister("ksV08", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee62a36540188146$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $ee62a36540188146$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $ee62a36540188146$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $ee62a36540188146$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $ee62a36540188146$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $ee62a36540188146$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $ee62a36540188146$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $ee62a36540188146$var$localize = {
    ordinalNumber: $ee62a36540188146$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $ee62a36540188146$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $ee62a36540188146$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $ee62a36540188146$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $ee62a36540188146$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $ee62a36540188146$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $ee62a36540188146$export$2e2bcd8739ae039 = $ee62a36540188146$var$localize;

});

parcelRegister("hK2kn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cea889c2875e1cb9$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $cea889c2875e1cb9$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $cea889c2875e1cb9$var$parseOrdinalNumberPattern = /\d+/i;
var $cea889c2875e1cb9$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $cea889c2875e1cb9$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $cea889c2875e1cb9$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $cea889c2875e1cb9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cea889c2875e1cb9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $cea889c2875e1cb9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $cea889c2875e1cb9$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $cea889c2875e1cb9$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $cea889c2875e1cb9$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $cea889c2875e1cb9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $cea889c2875e1cb9$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $cea889c2875e1cb9$var$matchOrdinalNumberPattern,
        parsePattern: $cea889c2875e1cb9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $cea889c2875e1cb9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cea889c2875e1cb9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $cea889c2875e1cb9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cea889c2875e1cb9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $cea889c2875e1cb9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cea889c2875e1cb9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $cea889c2875e1cb9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cea889c2875e1cb9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $cea889c2875e1cb9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $cea889c2875e1cb9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $cea889c2875e1cb9$export$2e2bcd8739ae039 = $cea889c2875e1cb9$var$match;

});


parcelRegister("8mQhO", function(module, exports) {
$parcel$export(module.exports, "default", () => $6178efbfd3f39087$export$2e2bcd8739ae039);

var $kc55z = parcelRequire("kc55z");

var $bEh5r = parcelRequire("bEh5r");

var $l7nFo = parcelRequire("l7nFo");

var $JRRaq = parcelRequire("JRRaq");

var $379G7 = parcelRequire("379G7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $6178efbfd3f39087$var$locale = {
    code: 'hu',
    formatDistance: (0, $kc55z.default),
    formatLong: (0, $bEh5r.default),
    formatRelative: (0, $l7nFo.default),
    localize: (0, $JRRaq.default),
    match: (0, $379G7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $6178efbfd3f39087$export$2e2bcd8739ae039 = $6178efbfd3f39087$var$locale;

});
parcelRegister("kc55z", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb38e02643eb28f4$export$2e2bcd8739ae039);
var $eb38e02643eb28f4$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $eb38e02643eb28f4$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $eb38e02643eb28f4$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var $eb38e02643eb28f4$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $eb38e02643eb28f4$var$withSuffixes[key][comparison] : $eb38e02643eb28f4$var$withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $eb38e02643eb28f4$var$translations[adv] + ' ' + result;
    }
    return result;
};
var $eb38e02643eb28f4$export$2e2bcd8739ae039 = $eb38e02643eb28f4$var$formatDistance;

});

parcelRegister("bEh5r", function(module, exports) {
$parcel$export(module.exports, "default", () => $87b0af36149cbca6$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $87b0af36149cbca6$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $87b0af36149cbca6$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $87b0af36149cbca6$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $87b0af36149cbca6$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $87b0af36149cbca6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $87b0af36149cbca6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $87b0af36149cbca6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $87b0af36149cbca6$export$2e2bcd8739ae039 = $87b0af36149cbca6$var$formatLong;

});

parcelRegister("l7nFo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5fc9c231ebf3dbc$export$2e2bcd8739ae039);
var $f5fc9c231ebf3dbc$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $f5fc9c231ebf3dbc$var$week(isFuture) {
    return function(date) {
        var weekday = $f5fc9c231ebf3dbc$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $f5fc9c231ebf3dbc$var$formatRelativeLocale = {
    lastWeek: $f5fc9c231ebf3dbc$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $f5fc9c231ebf3dbc$var$week(true),
    other: 'P'
};
var $f5fc9c231ebf3dbc$var$formatRelative = function formatRelative(token, date) {
    var format = $f5fc9c231ebf3dbc$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $f5fc9c231ebf3dbc$export$2e2bcd8739ae039 = $f5fc9c231ebf3dbc$var$formatRelative;

});

parcelRegister("JRRaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $089dfadecd18e8ad$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $089dfadecd18e8ad$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $089dfadecd18e8ad$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $089dfadecd18e8ad$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $089dfadecd18e8ad$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $089dfadecd18e8ad$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $089dfadecd18e8ad$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var $089dfadecd18e8ad$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $089dfadecd18e8ad$var$localize = {
    ordinalNumber: $089dfadecd18e8ad$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $089dfadecd18e8ad$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $089dfadecd18e8ad$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $089dfadecd18e8ad$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, $alRTX.default)({
        values: $089dfadecd18e8ad$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $089dfadecd18e8ad$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $089dfadecd18e8ad$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $089dfadecd18e8ad$export$2e2bcd8739ae039 = $089dfadecd18e8ad$var$localize;

});

parcelRegister("379G7", function(module, exports) {
$parcel$export(module.exports, "default", () => $244988714d7b9b96$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $244988714d7b9b96$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $244988714d7b9b96$var$parseOrdinalNumberPattern = /\d+/i;
var $244988714d7b9b96$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $244988714d7b9b96$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $244988714d7b9b96$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $244988714d7b9b96$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $244988714d7b9b96$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $244988714d7b9b96$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $244988714d7b9b96$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $244988714d7b9b96$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $244988714d7b9b96$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $244988714d7b9b96$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $244988714d7b9b96$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $244988714d7b9b96$var$matchOrdinalNumberPattern,
        parsePattern: $244988714d7b9b96$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $244988714d7b9b96$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $244988714d7b9b96$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $244988714d7b9b96$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $244988714d7b9b96$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $244988714d7b9b96$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $244988714d7b9b96$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $244988714d7b9b96$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $244988714d7b9b96$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $244988714d7b9b96$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $244988714d7b9b96$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $244988714d7b9b96$export$2e2bcd8739ae039 = $244988714d7b9b96$var$match;

});


parcelRegister("7ah7A", function(module, exports) {
$parcel$export(module.exports, "default", () => $5376bf8014a65864$export$2e2bcd8739ae039);

var $4sIVT = parcelRequire("4sIVT");

var $6xklk = parcelRequire("6xklk");

var $bNwx1 = parcelRequire("bNwx1");

var $bSvDI = parcelRequire("bSvDI");

var $jWktI = parcelRequire("jWktI");
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $5376bf8014a65864$var$locale = {
    code: 'is',
    formatDistance: (0, $4sIVT.default),
    formatLong: (0, $6xklk.default),
    formatRelative: (0, $bNwx1.default),
    localize: (0, $bSvDI.default),
    match: (0, $jWktI.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5376bf8014a65864$export$2e2bcd8739ae039 = $5376bf8014a65864$var$locale;

});
parcelRegister("4sIVT", function(module, exports) {
$parcel$export(module.exports, "default", () => $33fca1ab10c59caf$export$2e2bcd8739ae039);
var $33fca1ab10c59caf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $33fca1ab10c59caf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $33fca1ab10c59caf$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $33fca1ab10c59caf$export$2e2bcd8739ae039 = $33fca1ab10c59caf$var$formatDistance;

});

parcelRegister("6xklk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c259add6c8a9427$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $4c259add6c8a9427$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var $4c259add6c8a9427$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4c259add6c8a9427$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $4c259add6c8a9427$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $4c259add6c8a9427$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $4c259add6c8a9427$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $4c259add6c8a9427$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4c259add6c8a9427$export$2e2bcd8739ae039 = $4c259add6c8a9427$var$formatLong;

});

parcelRegister("bNwx1", function(module, exports) {
$parcel$export(module.exports, "default", () => $896d8164505eba99$export$2e2bcd8739ae039);
var $896d8164505eba99$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var $896d8164505eba99$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $896d8164505eba99$var$formatRelativeLocale[token];
};
var $896d8164505eba99$export$2e2bcd8739ae039 = $896d8164505eba99$var$formatRelative;

});

parcelRegister("bSvDI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a5d47d0d8422668$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $8a5d47d0d8422668$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var $8a5d47d0d8422668$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $8a5d47d0d8422668$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var $8a5d47d0d8422668$var$dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var $8a5d47d0d8422668$var$dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $8a5d47d0d8422668$var$formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $8a5d47d0d8422668$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $8a5d47d0d8422668$var$localize = {
    ordinalNumber: $8a5d47d0d8422668$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $8a5d47d0d8422668$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $8a5d47d0d8422668$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $8a5d47d0d8422668$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $8a5d47d0d8422668$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $8a5d47d0d8422668$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8a5d47d0d8422668$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8a5d47d0d8422668$export$2e2bcd8739ae039 = $8a5d47d0d8422668$var$localize;

});

parcelRegister("jWktI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e84351ad3b8ee1ff$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $e84351ad3b8ee1ff$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $e84351ad3b8ee1ff$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $e84351ad3b8ee1ff$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $e84351ad3b8ee1ff$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $e84351ad3b8ee1ff$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $e84351ad3b8ee1ff$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $e84351ad3b8ee1ff$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $e84351ad3b8ee1ff$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $e84351ad3b8ee1ff$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $e84351ad3b8ee1ff$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $e84351ad3b8ee1ff$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $e84351ad3b8ee1ff$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $e84351ad3b8ee1ff$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $e84351ad3b8ee1ff$var$matchOrdinalNumberPattern,
        parsePattern: $e84351ad3b8ee1ff$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $e84351ad3b8ee1ff$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e84351ad3b8ee1ff$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $e84351ad3b8ee1ff$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e84351ad3b8ee1ff$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $e84351ad3b8ee1ff$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e84351ad3b8ee1ff$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $e84351ad3b8ee1ff$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e84351ad3b8ee1ff$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $e84351ad3b8ee1ff$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e84351ad3b8ee1ff$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e84351ad3b8ee1ff$export$2e2bcd8739ae039 = $e84351ad3b8ee1ff$var$match;

});


parcelRegister("e0GTq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a332566d482a8d77$export$2e2bcd8739ae039);

var $dfnPz = parcelRequire("dfnPz");

var $cSBVp = parcelRequire("cSBVp");

var $43hO3 = parcelRequire("43hO3");

var $kqbVu = parcelRequire("kqbVu");

var $3D94H = parcelRequire("3D94H");
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $a332566d482a8d77$var$locale = {
    code: 'it',
    formatDistance: (0, $dfnPz.default),
    formatLong: (0, $cSBVp.default),
    formatRelative: (0, $43hO3.default),
    localize: (0, $kqbVu.default),
    match: (0, $3D94H.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a332566d482a8d77$export$2e2bcd8739ae039 = $a332566d482a8d77$var$locale;

});
parcelRegister("dfnPz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a4f2963d3201ec4$export$2e2bcd8739ae039);
var $9a4f2963d3201ec4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var $9a4f2963d3201ec4$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9a4f2963d3201ec4$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
var $9a4f2963d3201ec4$export$2e2bcd8739ae039 = $9a4f2963d3201ec4$var$formatDistance;

});

parcelRegister("cSBVp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9607f24aab38b24a$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $9607f24aab38b24a$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $9607f24aab38b24a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $9607f24aab38b24a$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $9607f24aab38b24a$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $9607f24aab38b24a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $9607f24aab38b24a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $9607f24aab38b24a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9607f24aab38b24a$export$2e2bcd8739ae039 = $9607f24aab38b24a$var$formatLong;

});

parcelRegister("43hO3", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f35413a534d48ef$export$2e2bcd8739ae039);

var $1on5Z = parcelRequire("1on5Z");
var $2f35413a534d48ef$var$weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function $2f35413a534d48ef$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $2f35413a534d48ef$var$weekdays[day] + " scorso alle' p";
    }
}
function $2f35413a534d48ef$var$thisWeek(day) {
    return "'" + $2f35413a534d48ef$var$weekdays[day] + " alle' p";
}
function $2f35413a534d48ef$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $2f35413a534d48ef$var$weekdays[day] + " prossimo alle' p";
    }
}
var $2f35413a534d48ef$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $1on5Z.default)(date, baseDate, options)) return $2f35413a534d48ef$var$thisWeek(day);
        else return $2f35413a534d48ef$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $1on5Z.default)(date, baseDate, options)) return $2f35413a534d48ef$var$thisWeek(day);
        else return $2f35413a534d48ef$var$_nextWeek(day);
    },
    other: 'P'
};
var $2f35413a534d48ef$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $2f35413a534d48ef$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $2f35413a534d48ef$export$2e2bcd8739ae039 = $2f35413a534d48ef$var$formatRelative;

});
parcelRegister("1on5Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $1039f2a90ff5e64c$export$2e2bcd8739ae039);

var $fIdV1 = parcelRequire("fIdV1");

var $5az51 = parcelRequire("5az51");
function $1039f2a90ff5e64c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $fIdV1.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $5az51.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $5az51.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});


parcelRegister("kqbVu", function(module, exports) {
$parcel$export(module.exports, "default", () => $eddf7ca3758938fc$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $eddf7ca3758938fc$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var $eddf7ca3758938fc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $eddf7ca3758938fc$var$monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var $eddf7ca3758938fc$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var $eddf7ca3758938fc$var$dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var $eddf7ca3758938fc$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var $eddf7ca3758938fc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $eddf7ca3758938fc$var$localize = {
    ordinalNumber: $eddf7ca3758938fc$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $eddf7ca3758938fc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $eddf7ca3758938fc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $eddf7ca3758938fc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $eddf7ca3758938fc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $eddf7ca3758938fc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $eddf7ca3758938fc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $eddf7ca3758938fc$export$2e2bcd8739ae039 = $eddf7ca3758938fc$var$localize;

});

parcelRegister("3D94H", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a4c0dabf68d4386$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $2a4c0dabf68d4386$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $2a4c0dabf68d4386$var$parseOrdinalNumberPattern = /\d+/i;
var $2a4c0dabf68d4386$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $2a4c0dabf68d4386$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $2a4c0dabf68d4386$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $2a4c0dabf68d4386$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2a4c0dabf68d4386$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $2a4c0dabf68d4386$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2a4c0dabf68d4386$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $2a4c0dabf68d4386$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $2a4c0dabf68d4386$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $2a4c0dabf68d4386$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $2a4c0dabf68d4386$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $2a4c0dabf68d4386$var$matchOrdinalNumberPattern,
        parsePattern: $2a4c0dabf68d4386$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $2a4c0dabf68d4386$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a4c0dabf68d4386$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $2a4c0dabf68d4386$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a4c0dabf68d4386$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $2a4c0dabf68d4386$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a4c0dabf68d4386$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $2a4c0dabf68d4386$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2a4c0dabf68d4386$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $2a4c0dabf68d4386$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2a4c0dabf68d4386$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2a4c0dabf68d4386$export$2e2bcd8739ae039 = $2a4c0dabf68d4386$var$match;

});


parcelRegister("59R5I", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c16f9cc936b6d45$export$2e2bcd8739ae039);

var $j8MVI = parcelRequire("j8MVI");

var $8zmdS = parcelRequire("8zmdS");

var $4Z1Vh = parcelRequire("4Z1Vh");

var $gAiW6 = parcelRequire("gAiW6");

var $j6bij = parcelRequire("j6bij");
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $3c16f9cc936b6d45$var$locale = {
    code: 'ja',
    formatDistance: (0, $j8MVI.default),
    formatLong: (0, $8zmdS.default),
    formatRelative: (0, $4Z1Vh.default),
    localize: (0, $gAiW6.default),
    match: (0, $j6bij.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $3c16f9cc936b6d45$export$2e2bcd8739ae039 = $3c16f9cc936b6d45$var$locale;

});
parcelRegister("j8MVI", function(module, exports) {
$parcel$export(module.exports, "default", () => $def4b824def9ac52$export$2e2bcd8739ae039);
var $def4b824def9ac52$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var $def4b824def9ac52$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $def4b824def9ac52$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
var $def4b824def9ac52$export$2e2bcd8739ae039 = $def4b824def9ac52$var$formatDistance;

});

parcelRegister("8zmdS", function(module, exports) {
$parcel$export(module.exports, "default", () => $63d2d499ef351710$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $63d2d499ef351710$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $63d2d499ef351710$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $63d2d499ef351710$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $63d2d499ef351710$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $63d2d499ef351710$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $63d2d499ef351710$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $63d2d499ef351710$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $63d2d499ef351710$export$2e2bcd8739ae039 = $63d2d499ef351710$var$formatLong;

});

parcelRegister("4Z1Vh", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a0e59c68f8e45ec$export$2e2bcd8739ae039);
var $3a0e59c68f8e45ec$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var $3a0e59c68f8e45ec$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3a0e59c68f8e45ec$var$formatRelativeLocale[token];
};
var $3a0e59c68f8e45ec$export$2e2bcd8739ae039 = $3a0e59c68f8e45ec$var$formatRelative;

});

parcelRegister("gAiW6", function(module, exports) {
$parcel$export(module.exports, "default", () => $031da80a20b32987$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $031da80a20b32987$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $031da80a20b32987$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $031da80a20b32987$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $031da80a20b32987$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $031da80a20b32987$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $031da80a20b32987$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $031da80a20b32987$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var $031da80a20b32987$var$localize = {
    ordinalNumber: $031da80a20b32987$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $031da80a20b32987$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $031da80a20b32987$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $031da80a20b32987$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $031da80a20b32987$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $031da80a20b32987$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $031da80a20b32987$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $031da80a20b32987$export$2e2bcd8739ae039 = $031da80a20b32987$var$localize;

});

parcelRegister("j6bij", function(module, exports) {
$parcel$export(module.exports, "default", () => $de7756b4c2241320$export$2e2bcd8739ae039);

var $Bwtuj = parcelRequire("Bwtuj");

var $jTS6J = parcelRequire("jTS6J");
var $de7756b4c2241320$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $de7756b4c2241320$var$parseOrdinalNumberPattern = /\d+/i;
var $de7756b4c2241320$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $de7756b4c2241320$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $de7756b4c2241320$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $de7756b4c2241320$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $de7756b4c2241320$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $de7756b4c2241320$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $de7756b4c2241320$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $de7756b4c2241320$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $de7756b4c2241320$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $de7756b4c2241320$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $de7756b4c2241320$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $de7756b4c2241320$var$matchOrdinalNumberPattern,
        parsePattern: $de7756b4c2241320$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $de7756b4c2241320$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $de7756b4c2241320$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $de7756b4c2241320$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $de7756b4c2241320$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $de7756b4c2241320$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $de7756b4c2241320$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $de7756b4c2241320$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $de7756b4c2241320$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $de7756b4c2241320$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $de7756b4c2241320$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $de7756b4c2241320$export$2e2bcd8739ae039 = $de7756b4c2241320$var$match;

});


parcelRegister("ieyUQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4649e60f0bc84f5$export$2e2bcd8739ae039);

var $5rXoN = parcelRequire("5rXoN");

var $41KKK = parcelRequire("41KKK");

var $aox8J = parcelRequire("aox8J");

var $4ibfs = parcelRequire("4ibfs");

var $11uzK = parcelRequire("11uzK");
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $d4649e60f0bc84f5$var$locale = {
    code: 'ko',
    formatDistance: (0, $5rXoN.default),
    formatLong: (0, $41KKK.default),
    formatRelative: (0, $aox8J.default),
    localize: (0, $4ibfs.default),
    match: (0, $11uzK.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $d4649e60f0bc84f5$export$2e2bcd8739ae039 = $d4649e60f0bc84f5$var$locale;

});
parcelRegister("5rXoN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f7d8cc6beab718f$export$2e2bcd8739ae039);
var $3f7d8cc6beab718f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var $3f7d8cc6beab718f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3f7d8cc6beab718f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
var $3f7d8cc6beab718f$export$2e2bcd8739ae039 = $3f7d8cc6beab718f$var$formatDistance;

});

parcelRegister("41KKK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2eeb8597f48dc8bc$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $2eeb8597f48dc8bc$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var $2eeb8597f48dc8bc$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $2eeb8597f48dc8bc$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $2eeb8597f48dc8bc$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $2eeb8597f48dc8bc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $2eeb8597f48dc8bc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $2eeb8597f48dc8bc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2eeb8597f48dc8bc$export$2e2bcd8739ae039 = $2eeb8597f48dc8bc$var$formatLong;

});

parcelRegister("aox8J", function(module, exports) {
$parcel$export(module.exports, "default", () => $7915da241fd0a44c$export$2e2bcd8739ae039);
var $7915da241fd0a44c$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var $7915da241fd0a44c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7915da241fd0a44c$var$formatRelativeLocale[token];
};
var $7915da241fd0a44c$export$2e2bcd8739ae039 = $7915da241fd0a44c$var$formatRelative;

});

parcelRegister("4ibfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $3201918ef76bbafa$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $3201918ef76bbafa$var$eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $3201918ef76bbafa$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $3201918ef76bbafa$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $3201918ef76bbafa$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $3201918ef76bbafa$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $3201918ef76bbafa$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $3201918ef76bbafa$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var $3201918ef76bbafa$var$localize = {
    ordinalNumber: $3201918ef76bbafa$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $3201918ef76bbafa$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $3201918ef76bbafa$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $3201918ef76bbafa$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $3201918ef76bbafa$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $3201918ef76bbafa$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3201918ef76bbafa$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3201918ef76bbafa$export$2e2bcd8739ae039 = $3201918ef76bbafa$var$localize;

});

parcelRegister("11uzK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bed9a239ca809c9$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $0bed9a239ca809c9$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $0bed9a239ca809c9$var$parseOrdinalNumberPattern = /\d+/i;
var $0bed9a239ca809c9$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $0bed9a239ca809c9$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $0bed9a239ca809c9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $0bed9a239ca809c9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0bed9a239ca809c9$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $0bed9a239ca809c9$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $0bed9a239ca809c9$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $0bed9a239ca809c9$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $0bed9a239ca809c9$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $0bed9a239ca809c9$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $0bed9a239ca809c9$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $0bed9a239ca809c9$var$matchOrdinalNumberPattern,
        parsePattern: $0bed9a239ca809c9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $0bed9a239ca809c9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0bed9a239ca809c9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $0bed9a239ca809c9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0bed9a239ca809c9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $0bed9a239ca809c9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0bed9a239ca809c9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $0bed9a239ca809c9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0bed9a239ca809c9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $0bed9a239ca809c9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0bed9a239ca809c9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0bed9a239ca809c9$export$2e2bcd8739ae039 = $0bed9a239ca809c9$var$match;

});


parcelRegister("irUpT", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6e682cc6432989c$export$2e2bcd8739ae039);

var $4fvK6 = parcelRequire("4fvK6");

var $l3BgE = parcelRequire("l3BgE");

var $1PdCe = parcelRequire("1PdCe");

var $5Azak = parcelRequire("5Azak");

var $7DiNM = parcelRequire("7DiNM");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $d6e682cc6432989c$var$locale = {
    code: 'nb',
    formatDistance: (0, $4fvK6.default),
    formatLong: (0, $l3BgE.default),
    formatRelative: (0, $1PdCe.default),
    localize: (0, $5Azak.default),
    match: (0, $7DiNM.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d6e682cc6432989c$export$2e2bcd8739ae039 = $d6e682cc6432989c$var$locale;

});
parcelRegister("4fvK6", function(module, exports) {
$parcel$export(module.exports, "default", () => $31812f8df79339c5$export$2e2bcd8739ae039);
var $31812f8df79339c5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $31812f8df79339c5$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $31812f8df79339c5$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $31812f8df79339c5$export$2e2bcd8739ae039 = $31812f8df79339c5$var$formatDistance;

});

parcelRegister("l3BgE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f546c957e72bd83d$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $f546c957e72bd83d$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $f546c957e72bd83d$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f546c957e72bd83d$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $f546c957e72bd83d$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $f546c957e72bd83d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $f546c957e72bd83d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $f546c957e72bd83d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f546c957e72bd83d$export$2e2bcd8739ae039 = $f546c957e72bd83d$var$formatLong;

});

parcelRegister("1PdCe", function(module, exports) {
$parcel$export(module.exports, "default", () => $15451da71ee7bfb0$export$2e2bcd8739ae039);
var $15451da71ee7bfb0$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $15451da71ee7bfb0$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $15451da71ee7bfb0$var$formatRelativeLocale[token];
};
var $15451da71ee7bfb0$export$2e2bcd8739ae039 = $15451da71ee7bfb0$var$formatRelative;

});

parcelRegister("5Azak", function(module, exports) {
$parcel$export(module.exports, "default", () => $411b97b603296d6b$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $411b97b603296d6b$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $411b97b603296d6b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $411b97b603296d6b$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $411b97b603296d6b$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $411b97b603296d6b$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $411b97b603296d6b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $411b97b603296d6b$var$localize = {
    ordinalNumber: $411b97b603296d6b$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $411b97b603296d6b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $411b97b603296d6b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $411b97b603296d6b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $411b97b603296d6b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $411b97b603296d6b$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $411b97b603296d6b$export$2e2bcd8739ae039 = $411b97b603296d6b$var$localize;

});

parcelRegister("7DiNM", function(module, exports) {
$parcel$export(module.exports, "default", () => $58eac29553507f2e$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $58eac29553507f2e$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $58eac29553507f2e$var$parseOrdinalNumberPattern = /\d+/i;
var $58eac29553507f2e$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $58eac29553507f2e$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $58eac29553507f2e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $58eac29553507f2e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $58eac29553507f2e$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $58eac29553507f2e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $58eac29553507f2e$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $58eac29553507f2e$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $58eac29553507f2e$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $58eac29553507f2e$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $58eac29553507f2e$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $58eac29553507f2e$var$matchOrdinalNumberPattern,
        parsePattern: $58eac29553507f2e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $58eac29553507f2e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $58eac29553507f2e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $58eac29553507f2e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $58eac29553507f2e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $58eac29553507f2e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $58eac29553507f2e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $58eac29553507f2e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $58eac29553507f2e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $58eac29553507f2e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $58eac29553507f2e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $58eac29553507f2e$export$2e2bcd8739ae039 = $58eac29553507f2e$var$match;

});


parcelRegister("35xWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $23fc2c91e229f657$export$2e2bcd8739ae039);

var $aQkQ8 = parcelRequire("aQkQ8");

var $5ixsx = parcelRequire("5ixsx");

var $fvN8v = parcelRequire("fvN8v");

var $f0cOk = parcelRequire("f0cOk");

var $lk0bP = parcelRequire("lk0bP");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $23fc2c91e229f657$var$locale = {
    code: 'nl',
    formatDistance: (0, $aQkQ8.default),
    formatLong: (0, $5ixsx.default),
    formatRelative: (0, $fvN8v.default),
    localize: (0, $f0cOk.default),
    match: (0, $lk0bP.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $23fc2c91e229f657$export$2e2bcd8739ae039 = $23fc2c91e229f657$var$locale;

});
parcelRegister("aQkQ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e4eed1144b57e41$export$2e2bcd8739ae039);
var $7e4eed1144b57e41$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $7e4eed1144b57e41$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7e4eed1144b57e41$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $7e4eed1144b57e41$export$2e2bcd8739ae039 = $7e4eed1144b57e41$var$formatDistance;

});

parcelRegister("5ixsx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3db89682f61655c9$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $3db89682f61655c9$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $3db89682f61655c9$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $3db89682f61655c9$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $3db89682f61655c9$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $3db89682f61655c9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $3db89682f61655c9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $3db89682f61655c9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3db89682f61655c9$export$2e2bcd8739ae039 = $3db89682f61655c9$var$formatLong;

});

parcelRegister("fvN8v", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4afddb66455d0ce$export$2e2bcd8739ae039);
var $b4afddb66455d0ce$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $b4afddb66455d0ce$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b4afddb66455d0ce$var$formatRelativeLocale[token];
};
var $b4afddb66455d0ce$export$2e2bcd8739ae039 = $b4afddb66455d0ce$var$formatRelative;

});

parcelRegister("f0cOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $aec0cb0b9b4b18d7$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $aec0cb0b9b4b18d7$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $aec0cb0b9b4b18d7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $aec0cb0b9b4b18d7$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $aec0cb0b9b4b18d7$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $aec0cb0b9b4b18d7$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $aec0cb0b9b4b18d7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $aec0cb0b9b4b18d7$var$localize = {
    ordinalNumber: $aec0cb0b9b4b18d7$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $aec0cb0b9b4b18d7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $aec0cb0b9b4b18d7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $aec0cb0b9b4b18d7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $aec0cb0b9b4b18d7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $aec0cb0b9b4b18d7$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $aec0cb0b9b4b18d7$export$2e2bcd8739ae039 = $aec0cb0b9b4b18d7$var$localize;

});

parcelRegister("lk0bP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f85b9ce80a789ed3$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $f85b9ce80a789ed3$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $f85b9ce80a789ed3$var$parseOrdinalNumberPattern = /\d+/i;
var $f85b9ce80a789ed3$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $f85b9ce80a789ed3$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $f85b9ce80a789ed3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $f85b9ce80a789ed3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f85b9ce80a789ed3$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $f85b9ce80a789ed3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $f85b9ce80a789ed3$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $f85b9ce80a789ed3$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $f85b9ce80a789ed3$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $f85b9ce80a789ed3$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $f85b9ce80a789ed3$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $f85b9ce80a789ed3$var$matchOrdinalNumberPattern,
        parsePattern: $f85b9ce80a789ed3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $f85b9ce80a789ed3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f85b9ce80a789ed3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $f85b9ce80a789ed3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f85b9ce80a789ed3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $f85b9ce80a789ed3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f85b9ce80a789ed3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $f85b9ce80a789ed3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f85b9ce80a789ed3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $f85b9ce80a789ed3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f85b9ce80a789ed3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f85b9ce80a789ed3$export$2e2bcd8739ae039 = $f85b9ce80a789ed3$var$match;

});


parcelRegister("jlGdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e160b98bdbf4f707$export$2e2bcd8739ae039);

var $7Xb6P = parcelRequire("7Xb6P");

var $fs1PU = parcelRequire("fs1PU");

var $kL39i = parcelRequire("kL39i");

var $jmCJF = parcelRequire("jmCJF");

var $8J7Ha = parcelRequire("8J7Ha");
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $e160b98bdbf4f707$var$locale = {
    code: 'pl',
    formatDistance: (0, $7Xb6P.default),
    formatLong: (0, $fs1PU.default),
    formatRelative: (0, $kL39i.default),
    localize: (0, $jmCJF.default),
    match: (0, $8J7Ha.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e160b98bdbf4f707$export$2e2bcd8739ae039 = $e160b98bdbf4f707$var$locale;

});
parcelRegister("7Xb6P", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ca6a92209cc0417$export$2e2bcd8739ae039);
var $5ca6a92209cc0417$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function $5ca6a92209cc0417$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $5ca6a92209cc0417$var$declension(scheme, count, time) {
    var group = $5ca6a92209cc0417$var$declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var $5ca6a92209cc0417$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $5ca6a92209cc0417$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $5ca6a92209cc0417$var$declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + $5ca6a92209cc0417$var$declension(scheme, count, 'future');
    else return $5ca6a92209cc0417$var$declension(scheme, count, 'past') + ' temu';
};
var $5ca6a92209cc0417$export$2e2bcd8739ae039 = $5ca6a92209cc0417$var$formatDistance;

});

parcelRegister("fs1PU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3fae533379bf3b8$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $b3fae533379bf3b8$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var $b3fae533379bf3b8$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b3fae533379bf3b8$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b3fae533379bf3b8$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $b3fae533379bf3b8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $b3fae533379bf3b8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $b3fae533379bf3b8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b3fae533379bf3b8$export$2e2bcd8739ae039 = $b3fae533379bf3b8$var$formatLong;

});

parcelRegister("kL39i", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1caa3bac9248fb4$export$2e2bcd8739ae039);

var $1on5Z = parcelRequire("1on5Z");
var $f1caa3bac9248fb4$var$adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var $f1caa3bac9248fb4$var$adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var $f1caa3bac9248fb4$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $f1caa3bac9248fb4$var$dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function $f1caa3bac9248fb4$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $1on5Z.default)(date, baseDate, options)) adjectives = $f1caa3bac9248fb4$var$adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = $f1caa3bac9248fb4$var$adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = $f1caa3bac9248fb4$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $f1caa3bac9248fb4$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $f1caa3bac9248fb4$var$formatRelativeLocale = {
    lastWeek: $f1caa3bac9248fb4$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $f1caa3bac9248fb4$var$dayAndTimeWithAdjective,
    other: 'P'
};
var $f1caa3bac9248fb4$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $f1caa3bac9248fb4$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
var $f1caa3bac9248fb4$export$2e2bcd8739ae039 = $f1caa3bac9248fb4$var$formatRelative;

});

parcelRegister("jmCJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e18e1e7a55121da0$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $e18e1e7a55121da0$var$eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var $e18e1e7a55121da0$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $e18e1e7a55121da0$var$monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var $e18e1e7a55121da0$var$monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var $e18e1e7a55121da0$var$dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $e18e1e7a55121da0$var$dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $e18e1e7a55121da0$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var $e18e1e7a55121da0$var$dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var $e18e1e7a55121da0$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $e18e1e7a55121da0$var$localize = {
    ordinalNumber: $e18e1e7a55121da0$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $e18e1e7a55121da0$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $e18e1e7a55121da0$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $e18e1e7a55121da0$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $e18e1e7a55121da0$var$monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $e18e1e7a55121da0$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $e18e1e7a55121da0$var$dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $e18e1e7a55121da0$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e18e1e7a55121da0$var$dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e18e1e7a55121da0$export$2e2bcd8739ae039 = $e18e1e7a55121da0$var$localize;

});

parcelRegister("8J7Ha", function(module, exports) {
$parcel$export(module.exports, "default", () => $65a87ecf745a60f6$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $65a87ecf745a60f6$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $65a87ecf745a60f6$var$parseOrdinalNumberPattern = /\d+/i;
var $65a87ecf745a60f6$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $65a87ecf745a60f6$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $65a87ecf745a60f6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $65a87ecf745a60f6$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $65a87ecf745a60f6$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $65a87ecf745a60f6$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $65a87ecf745a60f6$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $65a87ecf745a60f6$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $65a87ecf745a60f6$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $65a87ecf745a60f6$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $65a87ecf745a60f6$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $65a87ecf745a60f6$var$matchOrdinalNumberPattern,
        parsePattern: $65a87ecf745a60f6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $65a87ecf745a60f6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65a87ecf745a60f6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $65a87ecf745a60f6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65a87ecf745a60f6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $65a87ecf745a60f6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65a87ecf745a60f6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $65a87ecf745a60f6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $65a87ecf745a60f6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $65a87ecf745a60f6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $65a87ecf745a60f6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $65a87ecf745a60f6$export$2e2bcd8739ae039 = $65a87ecf745a60f6$var$match;

});


parcelRegister("glUk8", function(module, exports) {
$parcel$export(module.exports, "default", () => $be7a4c3c76413706$export$2e2bcd8739ae039);

var $4tfmq = parcelRequire("4tfmq");

var $1Q5sj = parcelRequire("1Q5sj");

var $hQZ0S = parcelRequire("hQZ0S");

var $4R7Ki = parcelRequire("4R7Ki");

var $agNpM = parcelRequire("agNpM");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $be7a4c3c76413706$var$locale = {
    code: 'pt',
    formatDistance: (0, $4tfmq.default),
    formatLong: (0, $1Q5sj.default),
    formatRelative: (0, $hQZ0S.default),
    localize: (0, $4R7Ki.default),
    match: (0, $agNpM.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $be7a4c3c76413706$export$2e2bcd8739ae039 = $be7a4c3c76413706$var$locale;

});
parcelRegister("4tfmq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3415c9313f991ce3$export$2e2bcd8739ae039);
var $3415c9313f991ce3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $3415c9313f991ce3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3415c9313f991ce3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $3415c9313f991ce3$export$2e2bcd8739ae039 = $3415c9313f991ce3$var$formatDistance;

});

parcelRegister("1Q5sj", function(module, exports) {
$parcel$export(module.exports, "default", () => $156ee12718c36a0b$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $156ee12718c36a0b$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var $156ee12718c36a0b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $156ee12718c36a0b$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $156ee12718c36a0b$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $156ee12718c36a0b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $156ee12718c36a0b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $156ee12718c36a0b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $156ee12718c36a0b$export$2e2bcd8739ae039 = $156ee12718c36a0b$var$formatLong;

});

parcelRegister("hQZ0S", function(module, exports) {
$parcel$export(module.exports, "default", () => $cff69ee92a4bcf98$export$2e2bcd8739ae039);
var $cff69ee92a4bcf98$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $cff69ee92a4bcf98$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $cff69ee92a4bcf98$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $cff69ee92a4bcf98$export$2e2bcd8739ae039 = $cff69ee92a4bcf98$var$formatRelative;

});

parcelRegister("4R7Ki", function(module, exports) {
$parcel$export(module.exports, "default", () => $38921ec8ecfbecb8$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $38921ec8ecfbecb8$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var $38921ec8ecfbecb8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $38921ec8ecfbecb8$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $38921ec8ecfbecb8$var$dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $38921ec8ecfbecb8$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var $38921ec8ecfbecb8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var $38921ec8ecfbecb8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $38921ec8ecfbecb8$var$localize = {
    ordinalNumber: $38921ec8ecfbecb8$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $38921ec8ecfbecb8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $38921ec8ecfbecb8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $38921ec8ecfbecb8$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $38921ec8ecfbecb8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $38921ec8ecfbecb8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $38921ec8ecfbecb8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $38921ec8ecfbecb8$export$2e2bcd8739ae039 = $38921ec8ecfbecb8$var$localize;

});

parcelRegister("agNpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $77a1bac3a9be1362$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $77a1bac3a9be1362$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $77a1bac3a9be1362$var$parseOrdinalNumberPattern = /\d+/i;
var $77a1bac3a9be1362$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $77a1bac3a9be1362$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $77a1bac3a9be1362$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $77a1bac3a9be1362$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $77a1bac3a9be1362$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $77a1bac3a9be1362$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $77a1bac3a9be1362$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $77a1bac3a9be1362$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $77a1bac3a9be1362$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $77a1bac3a9be1362$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $77a1bac3a9be1362$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $77a1bac3a9be1362$var$matchOrdinalNumberPattern,
        parsePattern: $77a1bac3a9be1362$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $77a1bac3a9be1362$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $77a1bac3a9be1362$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $77a1bac3a9be1362$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $77a1bac3a9be1362$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $77a1bac3a9be1362$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $77a1bac3a9be1362$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $77a1bac3a9be1362$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $77a1bac3a9be1362$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $77a1bac3a9be1362$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $77a1bac3a9be1362$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $77a1bac3a9be1362$export$2e2bcd8739ae039 = $77a1bac3a9be1362$var$match;

});


parcelRegister("7koEZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $555d87abf20ffa2e$export$2e2bcd8739ae039);

var $jiAmN = parcelRequire("jiAmN");

var $brdoH = parcelRequire("brdoH");

var $eziZk = parcelRequire("eziZk");

var $aRVll = parcelRequire("aRVll");

var $kwYgZ = parcelRequire("kwYgZ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $555d87abf20ffa2e$var$locale = {
    code: 'pt-BR',
    formatDistance: (0, $jiAmN.default),
    formatLong: (0, $brdoH.default),
    formatRelative: (0, $eziZk.default),
    localize: (0, $aRVll.default),
    match: (0, $kwYgZ.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $555d87abf20ffa2e$export$2e2bcd8739ae039 = $555d87abf20ffa2e$var$locale;

});
parcelRegister("jiAmN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0cbe868072cc1e2$export$2e2bcd8739ae039);
var $e0cbe868072cc1e2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $e0cbe868072cc1e2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e0cbe868072cc1e2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $e0cbe868072cc1e2$export$2e2bcd8739ae039 = $e0cbe868072cc1e2$var$formatDistance;

});

parcelRegister("brdoH", function(module, exports) {
$parcel$export(module.exports, "default", () => $853c9bbe5db9fa5f$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $853c9bbe5db9fa5f$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $853c9bbe5db9fa5f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $853c9bbe5db9fa5f$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $853c9bbe5db9fa5f$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $853c9bbe5db9fa5f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $853c9bbe5db9fa5f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $853c9bbe5db9fa5f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $853c9bbe5db9fa5f$export$2e2bcd8739ae039 = $853c9bbe5db9fa5f$var$formatLong;

});

parcelRegister("eziZk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9b3103d0e928c33$export$2e2bcd8739ae039);
var $a9b3103d0e928c33$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $a9b3103d0e928c33$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $a9b3103d0e928c33$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $a9b3103d0e928c33$export$2e2bcd8739ae039 = $a9b3103d0e928c33$var$formatRelative;

});

parcelRegister("aRVll", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e9b55cdbfa83fea$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $7e9b55cdbfa83fea$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var $7e9b55cdbfa83fea$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $7e9b55cdbfa83fea$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $7e9b55cdbfa83fea$var$dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $7e9b55cdbfa83fea$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var $7e9b55cdbfa83fea$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var $7e9b55cdbfa83fea$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var $7e9b55cdbfa83fea$var$localize = {
    ordinalNumber: $7e9b55cdbfa83fea$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $7e9b55cdbfa83fea$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $7e9b55cdbfa83fea$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $7e9b55cdbfa83fea$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $7e9b55cdbfa83fea$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $7e9b55cdbfa83fea$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $7e9b55cdbfa83fea$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $7e9b55cdbfa83fea$export$2e2bcd8739ae039 = $7e9b55cdbfa83fea$var$localize;

});

parcelRegister("kwYgZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef258cc0ad725019$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $ef258cc0ad725019$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $ef258cc0ad725019$var$parseOrdinalNumberPattern = /\d+/i;
var $ef258cc0ad725019$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $ef258cc0ad725019$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $ef258cc0ad725019$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $ef258cc0ad725019$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ef258cc0ad725019$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $ef258cc0ad725019$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $ef258cc0ad725019$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $ef258cc0ad725019$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $ef258cc0ad725019$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $ef258cc0ad725019$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $ef258cc0ad725019$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $ef258cc0ad725019$var$matchOrdinalNumberPattern,
        parsePattern: $ef258cc0ad725019$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $ef258cc0ad725019$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ef258cc0ad725019$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $ef258cc0ad725019$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ef258cc0ad725019$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $ef258cc0ad725019$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ef258cc0ad725019$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $ef258cc0ad725019$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ef258cc0ad725019$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $ef258cc0ad725019$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ef258cc0ad725019$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ef258cc0ad725019$export$2e2bcd8739ae039 = $ef258cc0ad725019$var$match;

});


parcelRegister("afHG0", function(module, exports) {
$parcel$export(module.exports, "default", () => $776d2f58d55334e4$export$2e2bcd8739ae039);

var $bfpHB = parcelRequire("bfpHB");

var $jZ5Kz = parcelRequire("jZ5Kz");

var $dhWXz = parcelRequire("dhWXz");

var $9peJu = parcelRequire("9peJu");

var $5BcwQ = parcelRequire("5BcwQ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $776d2f58d55334e4$var$locale = {
    code: 'ro',
    formatDistance: (0, $bfpHB.default),
    formatLong: (0, $jZ5Kz.default),
    formatRelative: (0, $dhWXz.default),
    localize: (0, $9peJu.default),
    match: (0, $5BcwQ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $776d2f58d55334e4$export$2e2bcd8739ae039 = $776d2f58d55334e4$var$locale;

});
parcelRegister("bfpHB", function(module, exports) {
$parcel$export(module.exports, "default", () => $021cfc0176fd7166$export$2e2bcd8739ae039);
var $021cfc0176fd7166$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var $021cfc0176fd7166$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $021cfc0176fd7166$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
var $021cfc0176fd7166$export$2e2bcd8739ae039 = $021cfc0176fd7166$var$formatDistance;

});

parcelRegister("jZ5Kz", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8c82caba009f6d1$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $e8c82caba009f6d1$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var $e8c82caba009f6d1$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e8c82caba009f6d1$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e8c82caba009f6d1$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $e8c82caba009f6d1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $e8c82caba009f6d1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $e8c82caba009f6d1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e8c82caba009f6d1$export$2e2bcd8739ae039 = $e8c82caba009f6d1$var$formatLong;

});

parcelRegister("dhWXz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9aca9918b0857b01$export$2e2bcd8739ae039);
var $9aca9918b0857b01$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var $9aca9918b0857b01$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9aca9918b0857b01$var$formatRelativeLocale[token];
};
var $9aca9918b0857b01$export$2e2bcd8739ae039 = $9aca9918b0857b01$var$formatRelative;

});

parcelRegister("9peJu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d91e07b1ecf7c3d$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $6d91e07b1ecf7c3d$var$eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $6d91e07b1ecf7c3d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var $6d91e07b1ecf7c3d$var$monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var $6d91e07b1ecf7c3d$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var $6d91e07b1ecf7c3d$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $6d91e07b1ecf7c3d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $6d91e07b1ecf7c3d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $6d91e07b1ecf7c3d$var$localize = {
    ordinalNumber: $6d91e07b1ecf7c3d$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $6d91e07b1ecf7c3d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $6d91e07b1ecf7c3d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $6d91e07b1ecf7c3d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $6d91e07b1ecf7c3d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $6d91e07b1ecf7c3d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6d91e07b1ecf7c3d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6d91e07b1ecf7c3d$export$2e2bcd8739ae039 = $6d91e07b1ecf7c3d$var$localize;

});

parcelRegister("5BcwQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $413a206039c17645$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $413a206039c17645$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $413a206039c17645$var$parseOrdinalNumberPattern = /\d+/i;
var $413a206039c17645$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $413a206039c17645$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $413a206039c17645$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $413a206039c17645$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $413a206039c17645$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $413a206039c17645$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $413a206039c17645$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $413a206039c17645$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $413a206039c17645$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $413a206039c17645$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $413a206039c17645$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $413a206039c17645$var$matchOrdinalNumberPattern,
        parsePattern: $413a206039c17645$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $413a206039c17645$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $413a206039c17645$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $413a206039c17645$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $413a206039c17645$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $413a206039c17645$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $413a206039c17645$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $413a206039c17645$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $413a206039c17645$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $413a206039c17645$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $413a206039c17645$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $413a206039c17645$export$2e2bcd8739ae039 = $413a206039c17645$var$match;

});


parcelRegister("8PQ29", function(module, exports) {
$parcel$export(module.exports, "default", () => $66eb72f533ce1fed$export$2e2bcd8739ae039);

var $3iBlU = parcelRequire("3iBlU");

var $jC7rI = parcelRequire("jC7rI");

var $ibk11 = parcelRequire("ibk11");

var $dHAc3 = parcelRequire("dHAc3");

var $dQFaY = parcelRequire("dQFaY");
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $66eb72f533ce1fed$var$locale = {
    code: 'ru',
    formatDistance: (0, $3iBlU.default),
    formatLong: (0, $jC7rI.default),
    formatRelative: (0, $ibk11.default),
    localize: (0, $dHAc3.default),
    match: (0, $dQFaY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $66eb72f533ce1fed$export$2e2bcd8739ae039 = $66eb72f533ce1fed$var$locale;

});
parcelRegister("3iBlU", function(module, exports) {
$parcel$export(module.exports, "default", () => $267006eda8f8b110$export$2e2bcd8739ae039);
function $267006eda8f8b110$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $267006eda8f8b110$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $267006eda8f8b110$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $267006eda8f8b110$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $267006eda8f8b110$var$declension(scheme.past, count);
                else return $267006eda8f8b110$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $267006eda8f8b110$var$declension(scheme.regular, count);
    };
}
var $267006eda8f8b110$var$formatDistanceLocale = {
    lessThanXSeconds: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $267006eda8f8b110$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var $267006eda8f8b110$var$formatDistance = function formatDistance(token, count, options) {
    return $267006eda8f8b110$var$formatDistanceLocale[token](count, options);
};
var $267006eda8f8b110$export$2e2bcd8739ae039 = $267006eda8f8b110$var$formatDistance;

});

parcelRegister("jC7rI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e477578fa380e85f$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $e477578fa380e85f$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $e477578fa380e85f$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $e477578fa380e85f$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $e477578fa380e85f$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $e477578fa380e85f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $e477578fa380e85f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $e477578fa380e85f$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $e477578fa380e85f$export$2e2bcd8739ae039 = $e477578fa380e85f$var$formatLong;

});

parcelRegister("ibk11", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3c8c7bfb6dee09c$export$2e2bcd8739ae039);

var $1on5Z = parcelRequire("1on5Z");
var $d3c8c7bfb6dee09c$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $d3c8c7bfb6dee09c$var$_lastWeek(day) {
    var weekday = $d3c8c7bfb6dee09c$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $d3c8c7bfb6dee09c$var$thisWeek(day) {
    var weekday = $d3c8c7bfb6dee09c$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $d3c8c7bfb6dee09c$var$_nextWeek(day) {
    var weekday = $d3c8c7bfb6dee09c$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $d3c8c7bfb6dee09c$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $1on5Z.default)(date, baseDate, options)) return $d3c8c7bfb6dee09c$var$thisWeek(day);
        else return $d3c8c7bfb6dee09c$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $1on5Z.default)(date, baseDate, options)) return $d3c8c7bfb6dee09c$var$thisWeek(day);
        else return $d3c8c7bfb6dee09c$var$_nextWeek(day);
    },
    other: 'P'
};
var $d3c8c7bfb6dee09c$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $d3c8c7bfb6dee09c$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $d3c8c7bfb6dee09c$export$2e2bcd8739ae039 = $d3c8c7bfb6dee09c$var$formatRelative;

});

parcelRegister("dHAc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f9b5dc100491a8c$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $9f9b5dc100491a8c$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $9f9b5dc100491a8c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $9f9b5dc100491a8c$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $9f9b5dc100491a8c$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $9f9b5dc100491a8c$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $9f9b5dc100491a8c$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $9f9b5dc100491a8c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var $9f9b5dc100491a8c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var $9f9b5dc100491a8c$var$localize = {
    ordinalNumber: $9f9b5dc100491a8c$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $9f9b5dc100491a8c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $9f9b5dc100491a8c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $9f9b5dc100491a8c$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $9f9b5dc100491a8c$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $9f9b5dc100491a8c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $9f9b5dc100491a8c$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $9f9b5dc100491a8c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9f9b5dc100491a8c$export$2e2bcd8739ae039 = $9f9b5dc100491a8c$var$localize;

});

parcelRegister("dQFaY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1501262a471145c$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $a1501262a471145c$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $a1501262a471145c$var$parseOrdinalNumberPattern = /\d+/i;
var $a1501262a471145c$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $a1501262a471145c$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $a1501262a471145c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $a1501262a471145c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a1501262a471145c$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $a1501262a471145c$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $a1501262a471145c$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $a1501262a471145c$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $a1501262a471145c$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $a1501262a471145c$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $a1501262a471145c$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $a1501262a471145c$var$matchOrdinalNumberPattern,
        parsePattern: $a1501262a471145c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $a1501262a471145c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1501262a471145c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $a1501262a471145c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1501262a471145c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $a1501262a471145c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1501262a471145c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $a1501262a471145c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1501262a471145c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $a1501262a471145c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1501262a471145c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a1501262a471145c$export$2e2bcd8739ae039 = $a1501262a471145c$var$match;

});


parcelRegister("4NUsi", function(module, exports) {
$parcel$export(module.exports, "default", () => $37f787ea2dc25aec$export$2e2bcd8739ae039);

var $kcfp5 = parcelRequire("kcfp5");

var $5GUJz = parcelRequire("5GUJz");

var $kyFeU = parcelRequire("kyFeU");

var $5Zlkl = parcelRequire("5Zlkl");

var $03TBQ = parcelRequire("03TBQ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $37f787ea2dc25aec$var$locale = {
    code: 'sk',
    formatDistance: (0, $kcfp5.default),
    formatLong: (0, $5GUJz.default),
    formatRelative: (0, $kyFeU.default),
    localize: (0, $5Zlkl.default),
    match: (0, $03TBQ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $37f787ea2dc25aec$export$2e2bcd8739ae039 = $37f787ea2dc25aec$var$locale;

});
parcelRegister("kcfp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb40e074dcd7200a$export$2e2bcd8739ae039);
function $eb40e074dcd7200a$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $eb40e074dcd7200a$var$declension(scheme, count, time) {
    var group = $eb40e074dcd7200a$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function $eb40e074dcd7200a$var$extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function $eb40e074dcd7200a$var$prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function $eb40e074dcd7200a$var$suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function $eb40e074dcd7200a$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $eb40e074dcd7200a$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var $eb40e074dcd7200a$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $eb40e074dcd7200a$var$extractPreposition(token) || '';
    var key = $eb40e074dcd7200a$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $eb40e074dcd7200a$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $eb40e074dcd7200a$var$prefixPreposition(preposition) + $eb40e074dcd7200a$var$suffixPreposition(preposition) + $eb40e074dcd7200a$var$declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return $eb40e074dcd7200a$var$prefixPreposition(preposition) + 'o ' + $eb40e074dcd7200a$var$suffixPreposition(preposition) + $eb40e074dcd7200a$var$declension(scheme, count, 'future');
    else return $eb40e074dcd7200a$var$prefixPreposition(preposition) + 'pred ' + $eb40e074dcd7200a$var$suffixPreposition(preposition) + $eb40e074dcd7200a$var$declension(scheme, count, 'past');
};
var $eb40e074dcd7200a$export$2e2bcd8739ae039 = $eb40e074dcd7200a$var$formatDistance;

});

parcelRegister("5GUJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $424ce22f471ce4cb$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $424ce22f471ce4cb$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $424ce22f471ce4cb$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $424ce22f471ce4cb$var$dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var $424ce22f471ce4cb$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $424ce22f471ce4cb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $424ce22f471ce4cb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $424ce22f471ce4cb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $424ce22f471ce4cb$export$2e2bcd8739ae039 = $424ce22f471ce4cb$var$formatLong;

});

parcelRegister("kyFeU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef76f8f2b70d60ab$export$2e2bcd8739ae039);

var $1on5Z = parcelRequire("1on5Z");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $ef76f8f2b70d60ab$var$accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function $ef76f8f2b70d60ab$var$_lastWeek(day) {
    var weekday = $ef76f8f2b70d60ab$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $ef76f8f2b70d60ab$var$thisWeek(day) {
    var weekday = $ef76f8f2b70d60ab$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $ef76f8f2b70d60ab$var$_nextWeek(day) {
    var weekday = $ef76f8f2b70d60ab$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $ef76f8f2b70d60ab$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $1on5Z.default)(date, baseDate, options)) return $ef76f8f2b70d60ab$var$thisWeek(day);
        else return $ef76f8f2b70d60ab$var$_lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $1on5Z.default)(date, baseDate, options)) return $ef76f8f2b70d60ab$var$thisWeek(day);
        else return $ef76f8f2b70d60ab$var$_nextWeek(day);
    },
    other: 'P'
};
var $ef76f8f2b70d60ab$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $ef76f8f2b70d60ab$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $ef76f8f2b70d60ab$export$2e2bcd8739ae039 = $ef76f8f2b70d60ab$var$formatRelative;

});

parcelRegister("5Zlkl", function(module, exports) {
$parcel$export(module.exports, "default", () => $45c3315ded3b6347$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $45c3315ded3b6347$var$eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $45c3315ded3b6347$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $45c3315ded3b6347$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $45c3315ded3b6347$var$formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $45c3315ded3b6347$var$dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $45c3315ded3b6347$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $45c3315ded3b6347$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var $45c3315ded3b6347$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $45c3315ded3b6347$var$localize = {
    ordinalNumber: $45c3315ded3b6347$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $45c3315ded3b6347$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $45c3315ded3b6347$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $45c3315ded3b6347$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $45c3315ded3b6347$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $45c3315ded3b6347$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $45c3315ded3b6347$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $45c3315ded3b6347$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $45c3315ded3b6347$export$2e2bcd8739ae039 = $45c3315ded3b6347$var$localize;

});

parcelRegister("03TBQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $00bb6ac7125ca4cf$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $00bb6ac7125ca4cf$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $00bb6ac7125ca4cf$var$parseOrdinalNumberPattern = /\d+/i;
var $00bb6ac7125ca4cf$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $00bb6ac7125ca4cf$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $00bb6ac7125ca4cf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $00bb6ac7125ca4cf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $00bb6ac7125ca4cf$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $00bb6ac7125ca4cf$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $00bb6ac7125ca4cf$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $00bb6ac7125ca4cf$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $00bb6ac7125ca4cf$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $00bb6ac7125ca4cf$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $00bb6ac7125ca4cf$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $00bb6ac7125ca4cf$var$matchOrdinalNumberPattern,
        parsePattern: $00bb6ac7125ca4cf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $00bb6ac7125ca4cf$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00bb6ac7125ca4cf$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $00bb6ac7125ca4cf$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00bb6ac7125ca4cf$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $00bb6ac7125ca4cf$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00bb6ac7125ca4cf$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $00bb6ac7125ca4cf$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00bb6ac7125ca4cf$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $00bb6ac7125ca4cf$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $00bb6ac7125ca4cf$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $00bb6ac7125ca4cf$export$2e2bcd8739ae039 = $00bb6ac7125ca4cf$var$match;

});


parcelRegister("1DRvc", function(module, exports) {
$parcel$export(module.exports, "default", () => $1322ef60a03965bd$export$2e2bcd8739ae039);

var $jb1F7 = parcelRequire("jb1F7");

var $c33DT = parcelRequire("c33DT");

var $azFYT = parcelRequire("azFYT");

var $e7GGQ = parcelRequire("e7GGQ");

var $4Vuzh = parcelRequire("4Vuzh");
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $1322ef60a03965bd$var$locale = {
    code: 'sv',
    formatDistance: (0, $jb1F7.default),
    formatLong: (0, $c33DT.default),
    formatRelative: (0, $azFYT.default),
    localize: (0, $e7GGQ.default),
    match: (0, $4Vuzh.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1322ef60a03965bd$export$2e2bcd8739ae039 = $1322ef60a03965bd$var$locale;

});
parcelRegister("jb1F7", function(module, exports) {
$parcel$export(module.exports, "default", () => $df6055751f1706a8$export$2e2bcd8739ae039);
var $df6055751f1706a8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $df6055751f1706a8$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var $df6055751f1706a8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $df6055751f1706a8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $df6055751f1706a8$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
var $df6055751f1706a8$export$2e2bcd8739ae039 = $df6055751f1706a8$var$formatDistance;

});

parcelRegister("c33DT", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c58972f72e3063f$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $8c58972f72e3063f$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $8c58972f72e3063f$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8c58972f72e3063f$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $8c58972f72e3063f$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $8c58972f72e3063f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $8c58972f72e3063f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $8c58972f72e3063f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8c58972f72e3063f$export$2e2bcd8739ae039 = $8c58972f72e3063f$var$formatLong;

});

parcelRegister("azFYT", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b2dbcdaf9773069$export$2e2bcd8739ae039);
var $7b2dbcdaf9773069$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $7b2dbcdaf9773069$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7b2dbcdaf9773069$var$formatRelativeLocale[token];
};
var $7b2dbcdaf9773069$export$2e2bcd8739ae039 = $7b2dbcdaf9773069$var$formatRelative;

});

parcelRegister("e7GGQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a482d582a24365d9$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $a482d582a24365d9$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $a482d582a24365d9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $a482d582a24365d9$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $a482d582a24365d9$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $a482d582a24365d9$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $a482d582a24365d9$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $a482d582a24365d9$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var $a482d582a24365d9$var$localize = {
    ordinalNumber: $a482d582a24365d9$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $a482d582a24365d9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $a482d582a24365d9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $a482d582a24365d9$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $a482d582a24365d9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $a482d582a24365d9$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a482d582a24365d9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a482d582a24365d9$export$2e2bcd8739ae039 = $a482d582a24365d9$var$localize;

});

parcelRegister("4Vuzh", function(module, exports) {
$parcel$export(module.exports, "default", () => $39643272a6d80904$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $39643272a6d80904$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $39643272a6d80904$var$parseOrdinalNumberPattern = /\d+/i;
var $39643272a6d80904$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $39643272a6d80904$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $39643272a6d80904$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $39643272a6d80904$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $39643272a6d80904$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $39643272a6d80904$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $39643272a6d80904$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $39643272a6d80904$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $39643272a6d80904$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $39643272a6d80904$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $39643272a6d80904$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $39643272a6d80904$var$matchOrdinalNumberPattern,
        parsePattern: $39643272a6d80904$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $39643272a6d80904$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $39643272a6d80904$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $39643272a6d80904$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $39643272a6d80904$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $39643272a6d80904$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $39643272a6d80904$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $39643272a6d80904$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $39643272a6d80904$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $39643272a6d80904$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $39643272a6d80904$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $39643272a6d80904$export$2e2bcd8739ae039 = $39643272a6d80904$var$match;

});


parcelRegister("jdMAw", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe4ebca77ad41dc$export$2e2bcd8739ae039);

var $ixfOj = parcelRequire("ixfOj");

var $fTsOh = parcelRequire("fTsOh");

var $6Uv3N = parcelRequire("6Uv3N");

var $lpCpa = parcelRequire("lpCpa");

var $gELe0 = parcelRequire("gELe0");
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $dfe4ebca77ad41dc$var$locale = {
    code: 'tr',
    formatDistance: (0, $ixfOj.default),
    formatLong: (0, $fTsOh.default),
    formatRelative: (0, $6Uv3N.default),
    localize: (0, $lpCpa.default),
    match: (0, $gELe0.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $dfe4ebca77ad41dc$export$2e2bcd8739ae039 = $dfe4ebca77ad41dc$var$locale;

});
parcelRegister("ixfOj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e792b3a2eaa6d6$export$2e2bcd8739ae039);
var $d7e792b3a2eaa6d6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var $d7e792b3a2eaa6d6$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d7e792b3a2eaa6d6$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
var $d7e792b3a2eaa6d6$export$2e2bcd8739ae039 = $d7e792b3a2eaa6d6$var$formatDistance;

});

parcelRegister("fTsOh", function(module, exports) {
$parcel$export(module.exports, "default", () => $b922572455a78632$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $b922572455a78632$var$dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var $b922572455a78632$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b922572455a78632$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b922572455a78632$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $b922572455a78632$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $b922572455a78632$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $b922572455a78632$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b922572455a78632$export$2e2bcd8739ae039 = $b922572455a78632$var$formatLong;

});

parcelRegister("6Uv3N", function(module, exports) {
$parcel$export(module.exports, "default", () => $508010f2d70d24e1$export$2e2bcd8739ae039);
var $508010f2d70d24e1$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var $508010f2d70d24e1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $508010f2d70d24e1$var$formatRelativeLocale[token];
};
var $508010f2d70d24e1$export$2e2bcd8739ae039 = $508010f2d70d24e1$var$formatRelative;

});

parcelRegister("lpCpa", function(module, exports) {
$parcel$export(module.exports, "default", () => $f969b933e4b04f7e$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $f969b933e4b04f7e$var$eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var $f969b933e4b04f7e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $f969b933e4b04f7e$var$monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $f969b933e4b04f7e$var$dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var $f969b933e4b04f7e$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var $f969b933e4b04f7e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var $f969b933e4b04f7e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $f969b933e4b04f7e$var$localize = {
    ordinalNumber: $f969b933e4b04f7e$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $f969b933e4b04f7e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $f969b933e4b04f7e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $f969b933e4b04f7e$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $f969b933e4b04f7e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $f969b933e4b04f7e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f969b933e4b04f7e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f969b933e4b04f7e$export$2e2bcd8739ae039 = $f969b933e4b04f7e$var$localize;

});

parcelRegister("gELe0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c20503a4437d8d34$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $c20503a4437d8d34$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $c20503a4437d8d34$var$parseOrdinalNumberPattern = /\d+/i;
var $c20503a4437d8d34$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $c20503a4437d8d34$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $c20503a4437d8d34$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $c20503a4437d8d34$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $c20503a4437d8d34$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $c20503a4437d8d34$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $c20503a4437d8d34$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $c20503a4437d8d34$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $c20503a4437d8d34$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $c20503a4437d8d34$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $c20503a4437d8d34$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $c20503a4437d8d34$var$matchOrdinalNumberPattern,
        parsePattern: $c20503a4437d8d34$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $c20503a4437d8d34$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c20503a4437d8d34$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $c20503a4437d8d34$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c20503a4437d8d34$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $c20503a4437d8d34$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c20503a4437d8d34$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $c20503a4437d8d34$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c20503a4437d8d34$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $c20503a4437d8d34$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c20503a4437d8d34$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c20503a4437d8d34$export$2e2bcd8739ae039 = $c20503a4437d8d34$var$match;

});


parcelRegister("8Bhf4", function(module, exports) {
$parcel$export(module.exports, "default", () => $642f2759e8b12759$export$2e2bcd8739ae039);

var $1eZMy = parcelRequire("1eZMy");

var $2u8o8 = parcelRequire("2u8o8");

var $kaGRZ = parcelRequire("kaGRZ");

var $li46r = parcelRequire("li46r");

var $hJcb3 = parcelRequire("hJcb3");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $642f2759e8b12759$var$locale = {
    code: 'zh-CN',
    formatDistance: (0, $1eZMy.default),
    formatLong: (0, $2u8o8.default),
    formatRelative: (0, $kaGRZ.default),
    localize: (0, $li46r.default),
    match: (0, $hJcb3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $642f2759e8b12759$export$2e2bcd8739ae039 = $642f2759e8b12759$var$locale;

});
parcelRegister("1eZMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e7705eb1ad0713e$export$2e2bcd8739ae039);
var $0e7705eb1ad0713e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var $0e7705eb1ad0713e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0e7705eb1ad0713e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
var $0e7705eb1ad0713e$export$2e2bcd8739ae039 = $0e7705eb1ad0713e$var$formatDistance;

});

parcelRegister("2u8o8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cf4e3de72e89c6d$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $1cf4e3de72e89c6d$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $1cf4e3de72e89c6d$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $1cf4e3de72e89c6d$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $1cf4e3de72e89c6d$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $1cf4e3de72e89c6d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $1cf4e3de72e89c6d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $1cf4e3de72e89c6d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1cf4e3de72e89c6d$export$2e2bcd8739ae039 = $1cf4e3de72e89c6d$var$formatLong;

});

parcelRegister("kaGRZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaf5fed9eeb5c977$export$2e2bcd8739ae039);

var $1on5Z = parcelRequire("1on5Z");
function $eaf5fed9eeb5c977$var$checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, $1on5Z.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $eaf5fed9eeb5c977$var$formatRelativeLocale = {
    lastWeek: $eaf5fed9eeb5c977$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $eaf5fed9eeb5c977$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var $eaf5fed9eeb5c977$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $eaf5fed9eeb5c977$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $eaf5fed9eeb5c977$export$2e2bcd8739ae039 = $eaf5fed9eeb5c977$var$formatRelative;

});

parcelRegister("li46r", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7fe76303d47661f$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $f7fe76303d47661f$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $f7fe76303d47661f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $f7fe76303d47661f$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $f7fe76303d47661f$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $f7fe76303d47661f$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $f7fe76303d47661f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $f7fe76303d47661f$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var $f7fe76303d47661f$var$localize = {
    ordinalNumber: $f7fe76303d47661f$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $f7fe76303d47661f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $f7fe76303d47661f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $f7fe76303d47661f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $f7fe76303d47661f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $f7fe76303d47661f$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f7fe76303d47661f$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f7fe76303d47661f$export$2e2bcd8739ae039 = $f7fe76303d47661f$var$localize;

});

parcelRegister("hJcb3", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce8015d181531e15$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $ce8015d181531e15$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $ce8015d181531e15$var$parseOrdinalNumberPattern = /\d+/i;
var $ce8015d181531e15$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $ce8015d181531e15$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $ce8015d181531e15$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $ce8015d181531e15$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $ce8015d181531e15$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $ce8015d181531e15$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $ce8015d181531e15$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $ce8015d181531e15$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $ce8015d181531e15$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $ce8015d181531e15$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $ce8015d181531e15$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $ce8015d181531e15$var$matchOrdinalNumberPattern,
        parsePattern: $ce8015d181531e15$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $ce8015d181531e15$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce8015d181531e15$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $ce8015d181531e15$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce8015d181531e15$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $ce8015d181531e15$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce8015d181531e15$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $ce8015d181531e15$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce8015d181531e15$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $ce8015d181531e15$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ce8015d181531e15$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ce8015d181531e15$export$2e2bcd8739ae039 = $ce8015d181531e15$var$match;

});


parcelRegister("8zwm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $63dab0e13a0f758a$export$2e2bcd8739ae039);

var $bqQgN = parcelRequire("bqQgN");

var $asW9v = parcelRequire("asW9v");

var $bvSYx = parcelRequire("bvSYx");

var $5QcRy = parcelRequire("5QcRy");

var $Gz5gG = parcelRequire("Gz5gG");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $63dab0e13a0f758a$var$locale = {
    code: 'zh-TW',
    formatDistance: (0, $bqQgN.default),
    formatLong: (0, $asW9v.default),
    formatRelative: (0, $bvSYx.default),
    localize: (0, $5QcRy.default),
    match: (0, $Gz5gG.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $63dab0e13a0f758a$export$2e2bcd8739ae039 = $63dab0e13a0f758a$var$locale;

});
parcelRegister("bqQgN", function(module, exports) {
$parcel$export(module.exports, "default", () => $852aab1dda3b0bd1$export$2e2bcd8739ae039);
var $852aab1dda3b0bd1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $852aab1dda3b0bd1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $852aab1dda3b0bd1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $852aab1dda3b0bd1$export$2e2bcd8739ae039 = $852aab1dda3b0bd1$var$formatDistance;

});

parcelRegister("asW9v", function(module, exports) {
$parcel$export(module.exports, "default", () => $79e9a0c2b6c14ca0$export$2e2bcd8739ae039);

var $g47F6 = parcelRequire("g47F6");
var $79e9a0c2b6c14ca0$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $79e9a0c2b6c14ca0$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $79e9a0c2b6c14ca0$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $79e9a0c2b6c14ca0$var$formatLong = {
    date: (0, $g47F6.default)({
        formats: $79e9a0c2b6c14ca0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $g47F6.default)({
        formats: $79e9a0c2b6c14ca0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $g47F6.default)({
        formats: $79e9a0c2b6c14ca0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $79e9a0c2b6c14ca0$export$2e2bcd8739ae039 = $79e9a0c2b6c14ca0$var$formatLong;

});

parcelRegister("bvSYx", function(module, exports) {
$parcel$export(module.exports, "default", () => $861d3be90aa1165e$export$2e2bcd8739ae039);
var $861d3be90aa1165e$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $861d3be90aa1165e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $861d3be90aa1165e$var$formatRelativeLocale[token];
};
var $861d3be90aa1165e$export$2e2bcd8739ae039 = $861d3be90aa1165e$var$formatRelative;

});

parcelRegister("5QcRy", function(module, exports) {
$parcel$export(module.exports, "default", () => $440bc95ba2880b5e$export$2e2bcd8739ae039);

var $alRTX = parcelRequire("alRTX");
var $440bc95ba2880b5e$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $440bc95ba2880b5e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $440bc95ba2880b5e$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $440bc95ba2880b5e$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $440bc95ba2880b5e$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $440bc95ba2880b5e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $440bc95ba2880b5e$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $440bc95ba2880b5e$var$localize = {
    ordinalNumber: $440bc95ba2880b5e$var$ordinalNumber,
    era: (0, $alRTX.default)({
        values: $440bc95ba2880b5e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $alRTX.default)({
        values: $440bc95ba2880b5e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $alRTX.default)({
        values: $440bc95ba2880b5e$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $alRTX.default)({
        values: $440bc95ba2880b5e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $alRTX.default)({
        values: $440bc95ba2880b5e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $440bc95ba2880b5e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $440bc95ba2880b5e$export$2e2bcd8739ae039 = $440bc95ba2880b5e$var$localize;

});

parcelRegister("Gz5gG", function(module, exports) {
$parcel$export(module.exports, "default", () => $07ff234dd3362a9b$export$2e2bcd8739ae039);

var $jTS6J = parcelRequire("jTS6J");

var $Bwtuj = parcelRequire("Bwtuj");
var $07ff234dd3362a9b$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $07ff234dd3362a9b$var$parseOrdinalNumberPattern = /\d+/i;
var $07ff234dd3362a9b$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $07ff234dd3362a9b$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $07ff234dd3362a9b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $07ff234dd3362a9b$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $07ff234dd3362a9b$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $07ff234dd3362a9b$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $07ff234dd3362a9b$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $07ff234dd3362a9b$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $07ff234dd3362a9b$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $07ff234dd3362a9b$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $07ff234dd3362a9b$var$match = {
    ordinalNumber: (0, $Bwtuj.default)({
        matchPattern: $07ff234dd3362a9b$var$matchOrdinalNumberPattern,
        parsePattern: $07ff234dd3362a9b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jTS6J.default)({
        matchPatterns: $07ff234dd3362a9b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $07ff234dd3362a9b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jTS6J.default)({
        matchPatterns: $07ff234dd3362a9b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $07ff234dd3362a9b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jTS6J.default)({
        matchPatterns: $07ff234dd3362a9b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $07ff234dd3362a9b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jTS6J.default)({
        matchPatterns: $07ff234dd3362a9b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $07ff234dd3362a9b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jTS6J.default)({
        matchPatterns: $07ff234dd3362a9b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $07ff234dd3362a9b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $07ff234dd3362a9b$export$2e2bcd8739ae039 = $07ff234dd3362a9b$var$match;

});


parcelRegister("27HF8", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $18be1aa8937ada53$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $18be1aa8937ada53$var$arrayEach;

});

parcelRegister("hBj11", function(module, exports) {

var $aisNj = parcelRequire("aisNj");
/** Used to compose bitmasks for cloning. */ var $cd04a4733f831689$var$CLONE_DEEP_FLAG = 1, $cd04a4733f831689$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $cd04a4733f831689$var$cloneDeep(value) {
    return $aisNj(value, $cd04a4733f831689$var$CLONE_DEEP_FLAG | $cd04a4733f831689$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $cd04a4733f831689$var$cloneDeep;

});
parcelRegister("aisNj", function(module, exports) {

var $2ATek = parcelRequire("2ATek");

var $27HF8 = parcelRequire("27HF8");

var $7b634 = parcelRequire("7b634");

var $28U6q = parcelRequire("28U6q");

var $l1ASd = parcelRequire("l1ASd");

var $1n9ln = parcelRequire("1n9ln");

var $iM6Ha = parcelRequire("iM6Ha");

var $8NUb3 = parcelRequire("8NUb3");

var $fYV7J = parcelRequire("fYV7J");

var $92hmd = parcelRequire("92hmd");

var $7L3er = parcelRequire("7L3er");

var $1GGsF = parcelRequire("1GGsF");

var $aQbTK = parcelRequire("aQbTK");

var $2LFJG = parcelRequire("2LFJG");

var $5LCp1 = parcelRequire("5LCp1");

var $jOlpf = parcelRequire("jOlpf");

var $2XMox = parcelRequire("2XMox");

var $jM0NZ = parcelRequire("jM0NZ");

var $cslvQ = parcelRequire("cslvQ");

var $1abWi = parcelRequire("1abWi");

var $k4FO8 = parcelRequire("k4FO8");

var $hOatB = parcelRequire("hOatB");
/** Used to compose bitmasks for cloning. */ var $77f1ebcbbdf12365$var$CLONE_DEEP_FLAG = 1, $77f1ebcbbdf12365$var$CLONE_FLAT_FLAG = 2, $77f1ebcbbdf12365$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $77f1ebcbbdf12365$var$argsTag = '[object Arguments]', $77f1ebcbbdf12365$var$arrayTag = '[object Array]', $77f1ebcbbdf12365$var$boolTag = '[object Boolean]', $77f1ebcbbdf12365$var$dateTag = '[object Date]', $77f1ebcbbdf12365$var$errorTag = '[object Error]', $77f1ebcbbdf12365$var$funcTag = '[object Function]', $77f1ebcbbdf12365$var$genTag = '[object GeneratorFunction]', $77f1ebcbbdf12365$var$mapTag = '[object Map]', $77f1ebcbbdf12365$var$numberTag = '[object Number]', $77f1ebcbbdf12365$var$objectTag = '[object Object]', $77f1ebcbbdf12365$var$regexpTag = '[object RegExp]', $77f1ebcbbdf12365$var$setTag = '[object Set]', $77f1ebcbbdf12365$var$stringTag = '[object String]', $77f1ebcbbdf12365$var$symbolTag = '[object Symbol]', $77f1ebcbbdf12365$var$weakMapTag = '[object WeakMap]';
var $77f1ebcbbdf12365$var$arrayBufferTag = '[object ArrayBuffer]', $77f1ebcbbdf12365$var$dataViewTag = '[object DataView]', $77f1ebcbbdf12365$var$float32Tag = '[object Float32Array]', $77f1ebcbbdf12365$var$float64Tag = '[object Float64Array]', $77f1ebcbbdf12365$var$int8Tag = '[object Int8Array]', $77f1ebcbbdf12365$var$int16Tag = '[object Int16Array]', $77f1ebcbbdf12365$var$int32Tag = '[object Int32Array]', $77f1ebcbbdf12365$var$uint8Tag = '[object Uint8Array]', $77f1ebcbbdf12365$var$uint8ClampedTag = '[object Uint8ClampedArray]', $77f1ebcbbdf12365$var$uint16Tag = '[object Uint16Array]', $77f1ebcbbdf12365$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $77f1ebcbbdf12365$var$cloneableTags = {};
$77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$argsTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$arrayTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$arrayBufferTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$dataViewTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$boolTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$dateTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$float32Tag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$float64Tag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$int8Tag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$int16Tag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$int32Tag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$mapTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$numberTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$objectTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$regexpTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$setTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$stringTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$symbolTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$uint8Tag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$uint8ClampedTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$uint16Tag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$uint32Tag] = true;
$77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$errorTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$funcTag] = $77f1ebcbbdf12365$var$cloneableTags[$77f1ebcbbdf12365$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $77f1ebcbbdf12365$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $77f1ebcbbdf12365$var$CLONE_DEEP_FLAG, isFlat = bitmask & $77f1ebcbbdf12365$var$CLONE_FLAT_FLAG, isFull = bitmask & $77f1ebcbbdf12365$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$cslvQ(value)) return value;
    var isArr = $jOlpf(value);
    if (isArr) {
        result = $aQbTK(value);
        if (!isDeep) return $iM6Ha(value, result);
    } else {
        var tag = $1GGsF(value), isFunc = tag == $77f1ebcbbdf12365$var$funcTag || tag == $77f1ebcbbdf12365$var$genTag;
        if ($2XMox(value)) return $1n9ln(value, isDeep);
        if (tag == $77f1ebcbbdf12365$var$objectTag || tag == $77f1ebcbbdf12365$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $5LCp1(value);
            if (!isDeep) return isFlat ? $fYV7J(value, $l1ASd(result, value)) : $8NUb3(value, $28U6q(result, value));
        } else {
            if (!$77f1ebcbbdf12365$var$cloneableTags[tag]) return object ? value : {};
            result = $2LFJG(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $2ATek);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1abWi(value)) value.forEach(function(subValue) {
        result.add($77f1ebcbbdf12365$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($jM0NZ(value)) value.forEach(function(subValue, key) {
        result.set(key, $77f1ebcbbdf12365$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $7L3er : $92hmd : isFlat ? $hOatB : $k4FO8;
    var props = isArr ? undefined : keysFunc(value);
    $27HF8(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $7b634(result, key, $77f1ebcbbdf12365$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $77f1ebcbbdf12365$var$baseClone;

});
parcelRegister("28U6q", function(module, exports) {

var $8b2ec = parcelRequire("8b2ec");

var $k4FO8 = parcelRequire("k4FO8");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $18f7d8f02765f375$var$baseAssign(object, source) {
    return object && $8b2ec(source, $k4FO8(source), object);
}
module.exports = $18f7d8f02765f375$var$baseAssign;

});

parcelRegister("l1ASd", function(module, exports) {

var $8b2ec = parcelRequire("8b2ec");

var $hOatB = parcelRequire("hOatB");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $f4e64b40fcaedfe9$var$baseAssignIn(object, source) {
    return object && $8b2ec(source, $hOatB(source), object);
}
module.exports = $f4e64b40fcaedfe9$var$baseAssignIn;

});

parcelRegister("8NUb3", function(module, exports) {

var $8b2ec = parcelRequire("8b2ec");

var $c5NEr = parcelRequire("c5NEr");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $668e79fdeec438d3$var$copySymbols(source, object) {
    return $8b2ec(source, $c5NEr(source), object);
}
module.exports = $668e79fdeec438d3$var$copySymbols;

});

parcelRegister("fYV7J", function(module, exports) {

var $8b2ec = parcelRequire("8b2ec");

var $67xOT = parcelRequire("67xOT");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ba28c52ae584fc85$var$copySymbolsIn(source, object) {
    return $8b2ec(source, $67xOT(source), object);
}
module.exports = $ba28c52ae584fc85$var$copySymbolsIn;

});

parcelRegister("aQbTK", function(module, exports) {
/** Used for built-in method references. */ var $7e47fd6aab73bea9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7e47fd6aab73bea9$var$hasOwnProperty = $7e47fd6aab73bea9$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7e47fd6aab73bea9$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $7e47fd6aab73bea9$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $7e47fd6aab73bea9$var$initCloneArray;

});

parcelRegister("2LFJG", function(module, exports) {

var $h5vRo = parcelRequire("h5vRo");

var $4RjB9 = parcelRequire("4RjB9");

var $ccE7u = parcelRequire("ccE7u");

var $kjinq = parcelRequire("kjinq");

var $evm8x = parcelRequire("evm8x");
/** `Object#toString` result references. */ var $2040586ef2e0c964$var$boolTag = '[object Boolean]', $2040586ef2e0c964$var$dateTag = '[object Date]', $2040586ef2e0c964$var$mapTag = '[object Map]', $2040586ef2e0c964$var$numberTag = '[object Number]', $2040586ef2e0c964$var$regexpTag = '[object RegExp]', $2040586ef2e0c964$var$setTag = '[object Set]', $2040586ef2e0c964$var$stringTag = '[object String]', $2040586ef2e0c964$var$symbolTag = '[object Symbol]';
var $2040586ef2e0c964$var$arrayBufferTag = '[object ArrayBuffer]', $2040586ef2e0c964$var$dataViewTag = '[object DataView]', $2040586ef2e0c964$var$float32Tag = '[object Float32Array]', $2040586ef2e0c964$var$float64Tag = '[object Float64Array]', $2040586ef2e0c964$var$int8Tag = '[object Int8Array]', $2040586ef2e0c964$var$int16Tag = '[object Int16Array]', $2040586ef2e0c964$var$int32Tag = '[object Int32Array]', $2040586ef2e0c964$var$uint8Tag = '[object Uint8Array]', $2040586ef2e0c964$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2040586ef2e0c964$var$uint16Tag = '[object Uint16Array]', $2040586ef2e0c964$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $2040586ef2e0c964$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $2040586ef2e0c964$var$arrayBufferTag:
            return $h5vRo(object);
        case $2040586ef2e0c964$var$boolTag:
        case $2040586ef2e0c964$var$dateTag:
            return new Ctor(+object);
        case $2040586ef2e0c964$var$dataViewTag:
            return $4RjB9(object, isDeep);
        case $2040586ef2e0c964$var$float32Tag:
        case $2040586ef2e0c964$var$float64Tag:
        case $2040586ef2e0c964$var$int8Tag:
        case $2040586ef2e0c964$var$int16Tag:
        case $2040586ef2e0c964$var$int32Tag:
        case $2040586ef2e0c964$var$uint8Tag:
        case $2040586ef2e0c964$var$uint8ClampedTag:
        case $2040586ef2e0c964$var$uint16Tag:
        case $2040586ef2e0c964$var$uint32Tag:
            return $evm8x(object, isDeep);
        case $2040586ef2e0c964$var$mapTag:
            return new Ctor;
        case $2040586ef2e0c964$var$numberTag:
        case $2040586ef2e0c964$var$stringTag:
            return new Ctor(object);
        case $2040586ef2e0c964$var$regexpTag:
            return $ccE7u(object);
        case $2040586ef2e0c964$var$setTag:
            return new Ctor;
        case $2040586ef2e0c964$var$symbolTag:
            return $kjinq(object);
    }
}
module.exports = $2040586ef2e0c964$var$initCloneByTag;

});
parcelRegister("4RjB9", function(module, exports) {

var $h5vRo = parcelRequire("h5vRo");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $389b507ad5fccf08$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $h5vRo(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $389b507ad5fccf08$var$cloneDataView;

});

parcelRegister("ccE7u", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $024aee5ad92b1c4f$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $024aee5ad92b1c4f$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $024aee5ad92b1c4f$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $024aee5ad92b1c4f$var$cloneRegExp;

});

parcelRegister("kjinq", function(module, exports) {

var $aAebX = parcelRequire("aAebX");
/** Used to convert symbols to primitives and strings. */ var $ec93d642a0cd6e99$var$symbolProto = $aAebX ? $aAebX.prototype : undefined, $ec93d642a0cd6e99$var$symbolValueOf = $ec93d642a0cd6e99$var$symbolProto ? $ec93d642a0cd6e99$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $ec93d642a0cd6e99$var$cloneSymbol(symbol) {
    return $ec93d642a0cd6e99$var$symbolValueOf ? Object($ec93d642a0cd6e99$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $ec93d642a0cd6e99$var$cloneSymbol;

});


parcelRegister("jM0NZ", function(module, exports) {

var $3przc = parcelRequire("3przc");

var $8UK9T = parcelRequire("8UK9T");

var $2NDhY = parcelRequire("2NDhY");
/* Node.js helper references. */ var $e6531ff42ed5d0ca$var$nodeIsMap = $2NDhY && $2NDhY.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $e6531ff42ed5d0ca$var$isMap = $e6531ff42ed5d0ca$var$nodeIsMap ? $8UK9T($e6531ff42ed5d0ca$var$nodeIsMap) : $3przc;
module.exports = $e6531ff42ed5d0ca$var$isMap;

});
parcelRegister("3przc", function(module, exports) {

var $1GGsF = parcelRequire("1GGsF");

var $czB45 = parcelRequire("czB45");
/** `Object#toString` result references. */ var $27b91711fccebae2$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $27b91711fccebae2$var$baseIsMap(value) {
    return $czB45(value) && $1GGsF(value) == $27b91711fccebae2$var$mapTag;
}
module.exports = $27b91711fccebae2$var$baseIsMap;

});


parcelRegister("1abWi", function(module, exports) {

var $cxeOS = parcelRequire("cxeOS");

var $8UK9T = parcelRequire("8UK9T");

var $2NDhY = parcelRequire("2NDhY");
/* Node.js helper references. */ var $0d8ffc8673f3b148$var$nodeIsSet = $2NDhY && $2NDhY.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0d8ffc8673f3b148$var$isSet = $0d8ffc8673f3b148$var$nodeIsSet ? $8UK9T($0d8ffc8673f3b148$var$nodeIsSet) : $cxeOS;
module.exports = $0d8ffc8673f3b148$var$isSet;

});
parcelRegister("cxeOS", function(module, exports) {

var $1GGsF = parcelRequire("1GGsF");

var $czB45 = parcelRequire("czB45");
/** `Object#toString` result references. */ var $92040ff0fcc27f83$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $92040ff0fcc27f83$var$baseIsSet(value) {
    return $czB45(value) && $1GGsF(value) == $92040ff0fcc27f83$var$setTag;
}
module.exports = $92040ff0fcc27f83$var$baseIsSet;

});




parcelRegister("a622V", function(module, exports) {
$parcel$export(module.exports, "getUserTiming", () => $759c0d3f7a611d43$export$4660d4a735328f2a);
var $759c0d3f7a611d43$var$n = "undefined" != typeof window ? window.performance : null;
function $759c0d3f7a611d43$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $759c0d3f7a611d43$export$abfb0136cf8e916b(),
        effectiveConnectionType: $759c0d3f7a611d43$export$265dfeca3f5017b9(),
        timeToFirstByte: $759c0d3f7a611d43$export$9a2904da0506c3ba(),
        firstPaint: $759c0d3f7a611d43$export$819e7a0b13f5961(),
        firstContentfulPaint: $759c0d3f7a611d43$export$3086fa1a9fb7f683(),
        domContentLoaded: $759c0d3f7a611d43$export$d6856d1fab905de0(),
        onLoad: $759c0d3f7a611d43$export$7259a7b98f0280a3()
    };
    return t.onLoad ? ((n.url || n.all) && (t.url = $759c0d3f7a611d43$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $759c0d3f7a611d43$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $759c0d3f7a611d43$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $759c0d3f7a611d43$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $759c0d3f7a611d43$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $759c0d3f7a611d43$export$a0d4d2a74c7df9f()), Promise.resolve(t)) : new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $759c0d3f7a611d43$export$a2a699fa5b2b1ed4(n);
    });
}
function $759c0d3f7a611d43$export$bf7f2fce5c1cf636(e) {
    $759c0d3f7a611d43$var$n && $759c0d3f7a611d43$var$n.mark && $759c0d3f7a611d43$var$n.mark(e);
}
function $759c0d3f7a611d43$export$83602b44513dc228(e, t) {
    if ($759c0d3f7a611d43$var$n && $759c0d3f7a611d43$var$n.measure) try {
        $759c0d3f7a611d43$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $759c0d3f7a611d43$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $759c0d3f7a611d43$export$819e7a0b13f5961() {
    if (!$759c0d3f7a611d43$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $759c0d3f7a611d43$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $759c0d3f7a611d43$export$3086fa1a9fb7f683() {
    if (!$759c0d3f7a611d43$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $759c0d3f7a611d43$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $759c0d3f7a611d43$export$9a2904da0506c3ba() {
    if (!$759c0d3f7a611d43$var$n) return null;
    var e = $759c0d3f7a611d43$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].responseStart) : null;
}
function $759c0d3f7a611d43$export$d6856d1fab905de0() {
    if (!$759c0d3f7a611d43$var$n) return null;
    var e = $759c0d3f7a611d43$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].domContentLoadedEventEnd) : null;
}
function $759c0d3f7a611d43$export$7259a7b98f0280a3() {
    if (!$759c0d3f7a611d43$var$n) return null;
    var e = $759c0d3f7a611d43$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].loadEventEnd) : null;
}
function $759c0d3f7a611d43$export$abfb0136cf8e916b(n) {
    void 0 === n && (n = $759c0d3f7a611d43$export$7935961ef7719cb0()), n = n.toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), d = !t && e("android"), l = d && e("mobile"), f = d && !e("mobile");
    return l || o || a || r ? "phone" : u || f || i ? "tablet" : "desktop";
}
function $759c0d3f7a611d43$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $759c0d3f7a611d43$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $759c0d3f7a611d43$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $759c0d3f7a611d43$export$4660d4a735328f2a() {
    if (!$759c0d3f7a611d43$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $759c0d3f7a611d43$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $759c0d3f7a611d43$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $759c0d3f7a611d43$export$a0d4d2a74c7df9f() {
    return $759c0d3f7a611d43$var$n && "undefined" != typeof PerformanceResourceTiming ? $759c0d3f7a611d43$var$n.getEntriesByType("navigation").concat($759c0d3f7a611d43$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $759c0d3f7a611d43$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}

});

const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

const $8fdfc4bb9d992697$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $8fdfc4bb9d992697$export$f005e2e9f707cb5f = 'commercial';
const $8fdfc4bb9d992697$export$17b81a3d6c98013c = 'isolated-cloud';
const $8fdfc4bb9d992697$export$a739cd5aac835909 = 'staging';
const $8fdfc4bb9d992697$export$42dd0cdd351a4a9 = 'prod';
const $8fdfc4bb9d992697$export$404582bc18fe4d9e = 'dev';
const $8fdfc4bb9d992697$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $8fdfc4bb9d992697$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $8fdfc4bb9d992697$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $8fdfc4bb9d992697$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $8fdfc4bb9d992697$export$b61e047ddcc35726 = 'GCP';
const $8fdfc4bb9d992697$export$1baf17f3e645a2b2 = 'AWS';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

const $c3b876b1e2716851$export$b98e411ae80c806f = '/';

// temp solution until a proper versioning
const $8312ee7c6ac197b8$export$93809551debf385f = '0.1.7';

const $dd841321bc924872$export$b98e411ae80c806f = '/';

/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';

/* eslint-disable jira/filename-case */ const $382ab3343e49976c$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


$parcel$global.rlb("5geQX")
//# sourceMappingURL=shared~commons~stable~ar.e7a0f90b.js.map
